import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link, withRouter } from "react-router-dom";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import Amplify, { Auth } from "aws-amplify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import Tooltip from "@material-ui/core/Tooltip";
import Linkify from "react-linkify";
import * as Modal from "react-modal";
import * as _ from "lodash";
// import SignatureCanvas from 'react-signature-canvas';
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";
import { animateScroll as scroll } from "react-scroll";
import * as SecretKeys from "../../ENV.json";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
// import Consumer from '../consumer/consumerSignup';
import MaskInputEinNumber from "../common/maskInputEinNumberPartner";
import MaskInputNumber from "../common/maskInputNumberPartner";
import TermAndCondition from "../common/termsAndConditionPartner";
import CardInputField from "../common/cardInputField";
import CardInputMaskinking from "../common/cardInputMaskinking";
import loader from "../../images/Spin-1s-107px.gif";
import imgIcon from "../../images/question.png";
import axios from "axios";
import { DebounceInput } from "react-debounce-input";
import Select from "react-select";

import {
  saveBusinessUserPatner,
  saveBusinessUserStep1,
  getAllCountry,
  getAllStates,
  getCityByStateId,
  getAllPlans,
  getAffiliateDetailByAffiliateKey,
  confirmUserEmail,
  clearData,
  getBusiness,
  getIndustry,
  checkEmailVerify,
  getPageDataFooter,
  getPageData,
  requestApiData,
  clearDataEmail,
  clearSignupData,
  saveConsumerUser,
  GetAllAffiliateUsersByAffiliateType,
  setPageName,
  planPriceChange,
} from "../../Actions/actions";

import TextFieldGroupPartner from "../common/TextFieldGroupPartner";
import EmailForm from "./signupEmailPage";

// import PlanPage from './planPage';

import logoImage from "../../images/logo.png";

Amplify.configure(SecretKeys.awsUserpool);
const Api = SecretKeys.ApiUrl.ProdUrl;
const customStyles = {
  content: {
    position: "unset",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: '-50%',
    // transform: 'translate(-50%, -50%)',
    margin: "100px auto",
    maxWidth: "359px",
    overflow: "initial",
    height: "295px",
    width: "100%",
  },
};

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      password: "",
      passwordType: "password",
      companyTitle: "",
      mobilePhone: "",
      workPhoneNumber: "",
      email: "",
      companyName: "",
      streeAddress: "",
      streeAddress2: "",
      city: "",
      state: "",
      zipCode: "",
      separateTaxId: "",
      enterpriseType: "",
      startingYear: "",
      webSite: "",
      industryTypeId: "",
      taxId: "",
      stateCard: "",
      isConsumer: false,
      successModalStatus: false,
      failureModalStatus: false,
      durationCheckout: 0,
      discountCheckout: 0,
      showTabPlan: false,
      showTabPlan1: false,
      showTabPlan2: false,
      showTabPlan3: false,
      showTabPlan4: false,
      showTabPlan5: false,
      errors: {
        firstNameError: true,
        lastNameError: true,
        nonWorkPhoneNumberError: true,
        workPhoneNumberError: true,
        companyTitleError: true,
        companyNameError: true,
        totalTaxIdError: false,
        streeAddressError: true,
        cityError: true,
        stateError: true,
        zipCodeError: true,
        taxIdError: true,
        separateTaxIdError: true,
      },
      errorsSignupPlan: {
        webSiteError: false,
        industryTypeIdError: true,
        bankruptcyStatusError: true,
        acceptCCError: true,
        enterpriseTypeError: true,
        dissolvedStatusError: true,
        startingYearError: true,
      },
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
        cardFirstNameError: true,
        cardLastNameError: true,
        recaptchaTokenError: true,
      },

      errorsConsumer: {
        cFirstNameError: true,
        cLastNameError: true,
        cPhoneError: true,
        cEmployerError: true,
        cSince: true,
        cStateError: true,
      },
      bussnessSigUpErrorStatus: {
        firstNameError: true,
        lastNameError: true,
        nonWorkPhoneNumberError: true,
        workPhoneNumberError: true,
        companyTitleError: true,
        companyNameError: true,
        totalTaxIdError: false,
        streeAddressError: true,
        cityError: true,
        stateError: true,
        zipCodeError: true,
        taxIdError: true,
        separateTaxIdError: true,
      },
      errorsSignupPlanStatus: {
        webSiteError: false,
        industryTypeIdError: true,
        bankruptcyStatusError: true,
        acceptCCError: true,
        enterpriseTypeError: true,
        dissolvedStatusError: true,
        startingYearError: true,
      },
      errorsConsumerStatus: {
        cFirstNameError: true,
        cLastNameError: true,
        cPhoneError: true,
        cEmployerError: true,
        cSince: true,
        cStateError: true,
      },
      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
        cardFirstNameError: true,
        cardLastNameError: true,
        recaptchaTokenError: true,
      },

      cognitoClientId: "",
      bankruptcyStatus: "",
      dissolvedStatus: "",
      acceptCC: "",
      planPriceId: 0,
      isLoading: false,
      businessTypeId: "",
      roleName: "Business-User",
      IsCompanyForm: 1,
      // defaultIndexSignC: 1,
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      errorsCompany: {},
      errorsTermPolicy: {},
      modalIsOpen: false,
      fileError: false,
      totalTaxId: 0.0,
      file: "",
      code: "",
      indicatorBusiness: "",
      indicatorConsumer: "",
      signatureImageContentType: "image/png",
      signatureImageFileSize: "",
      errorForcodeverify: false,
      isMounted: false,
      affiliateId: "",
      hearAboutUs: "",
      partnerType: "",
      defaultIndex: 1,
      countryCode: "+1",
      workCountryCode: "+1",
      cityId: "",
      nonWorkPhoneNumber: "",
      showTab: 1,
      affiliateKeyId: "",
      isLoginCheckS: false,
      plansDataAffiliate1: [],
      indexType: "defaultIndex",
      passwordColor: "black",
      cchangeSignature: 0,
      signatureDefaultValue: "",
      signatureFontFamily: "",
      emptyErrorSign: 1,
      AllPlansForMember1: [],
      intervalId: 0,
      pageType: "business",
      enableButtonT: true,
      userDataLogin1: [],
      paymentStatus: "pending",
      isLoader: false,
      isLoaderDataSave: false,
      consumerPlanPriceId: 23,
      selectedPlanName: "",
      selectedPlanAmount: "",
      BusinessUserDataStep1Data: {},
      cFirstName: "",
      cLastName: "",
      cState: "",
      cSince: "",
      cEmployer: "",
      cEmail: "",
      cPhone: "",
      cPassword: "",
      cNotification: "",
      cUpdateClaim: "",
      cTermsandCondition: "",
      serviceFeeAgree: "",
      bankAccount: "",
      otherIndustryType: "",
      tabValue: 0,
      tabValueConsumer: 0,
      IsSignatureForm: false,
      IsSignaUpForm1: false,
      errorsSignup: { emailError: true, passwordError: true },
      planId: "",
      planName: "",
      activeTab1: false,
      activeTab2: false,
      activeTab3: false,
      activeTab4: false,
      activeTab1Consumer: false,
      activeTab2Consumer: false,
      durationData: "1 Month",
      activePlanForBussness: "Premium",
      showplanDetail: false,
      cardNumber: "",
      cardLastName: "",
      cardFirstName: "",

      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      cardAddress: "",
      cardCity: "",
      cardZipCode: "",
      sameAddress: false,
      recaptchaToken: "",
      fusebillPlanId: "",
      fusebillPlanFrequencyId: "",
      connectFusebill: "",
      cClaimUpdateText: "",
      cRoleName: "Consumer",
      cOptionsSinceAdds: "",
      legalTabFilled: false,
      zendeskLink: "https://collectively.zendesk.com",
      backHandle: false,
      defaultOptionAffilateState: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitPlanPage = this.handleSubmitPlanPage.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeTaxId = this.onChangeTaxId.bind(this);
    this.onChange1 = this.onChange1.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this._onSelectCard = this._onSelectCard.bind(this);

    this._onSelectForBusiness = this._onSelectForBusiness.bind(this);
    this._onSelectForYears = this._onSelectForYears.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.finalSubmit = this.finalSubmit.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.codeOnSubmit = this.codeOnSubmit.bind(this);
    this._citySelect = this._citySelect.bind(this);
    this._cSince1 = this._cSince1.bind(this);
    this._cSince = this._cSince.bind(this);
    this._cSinceAdds = this._cSinceAdds.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this._countrySelectWork = this._countrySelectWork.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    // this.verifyEmail = this.verifyEmail.bind(this);
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.handleDataChidData = this.handleDataChidData.bind(this);
    this.viewPassword = this.viewPassword.bind(this);
    this.backClick = this.backClick.bind(this);
    this.recaptchaRef = React.createRef();
    this._onSelectForPartner = this._onSelectForPartner.bind(this);
  }

  handleDataChidData(data) {
    this.setState({
      showTab: data,
    });
  }

  handleSubmitTermPolicy = () => {};

  onReCaptchaChange = (value) => {
    this.setState({ recaptchaToken: value }, () => {
      this.isValidCardDetail("recaptchaToken");
    });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
  };

  handleSaveData = (name, checked) => {
    let value = "";

    if (name === "readDisclaimer" && checked === true) {
      value = "1";
    }
    if (name === "readPrivacyPolicy" && checked === true) {
      value = "1";
    }
    if (name === "readLetterOfAgency" && checked === true) {
      value = "1";
    }
    if (name === "readUserAgreement" && checked === true) {
      value = "1";
    }
    if (name === "bankAccount" && checked === true) {
      value = "1";
    }
    if (name === "serviceFeeAgree" && checked === true) {
      value = "1";
    }
    this.setState({
      [name]: value,
    });
    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  };

  handleClickUserType = (id) => {
    const { GetAllAffiliateUsersByAffiliateType } = this.props;
    const { defaultIndex } = this.state;

    window.scrollTo(0, 0);
    this.setState(
      {
        defaultIndex: id,
        isConsumer: id !== 1,
      },
      async () => {
        if (id !== defaultIndex) {
          this.setState({
            errorsConsumer: {
              cFirstNameError: true,
              cLastNameError: true,
              cPhoneError: true,
              cEmployerError: true,
              cSince: true,
              cStateError: true,
            },
            errors: {
              firstNameError: true,
              lastNameError: true,
              nonWorkPhoneNumberError: true,
              workPhoneNumberError: true,
              companyTitleError: true,
              companyNameError: true,
              totalTaxIdError: false,
              streeAddressError: true,
              cityError: true,
              stateError: true,
              zipCodeError: true,
              taxIdError: true,
              separateTaxIdError: true,
            },
            errorsSignupPlan: {
              webSiteError: false,
              industryTypeIdError: true,
              bankruptcyStatusError: true,
              acceptCCError: true,
              enterpriseTypeError: true,
              dissolvedStatusError: true,
              startingYearError: true,
            },
            cardErrors: {
              cardMonthError: true,
              cardNumberError: true,
              cardFirstNameError: true,
              cardLastNameError: true,
              recaptchaTokenError: true,
            },
            bussnessSigUpErrorStatus: {
              firstNameError: true,
              lastNameError: true,
              nonWorkPhoneNumberError: true,
              workPhoneNumberError: true,
              companyTitleError: true,
              companyNameError: true,
              streeAddressError: true,
              cityError: true,
              stateError: true,
              zipCodeError: true,
              taxIdError: true,
              separateTaxIdError: true,
              totalTaxIdError: false,
            },
            errorsSignupPlanStatus: {
              webSiteError: false,
              industryTypeIdError: true,
              bankruptcyStatusError: true,
              acceptCCError: true,
              enterpriseTypeError: true,
              dissolvedStatusError: true,
              startingYearError: true,
            },
            errorsConsumerStatus: {
              cFirstNameError: true,
              cLastNameError: true,
              cPhoneError: true,
              cEmployerError: true,
              cSince: true,
              cStateError: true,
            },
            cardErrorsState: {
              cardMonthError: true,
              cardNumberError: true,
              cardFirstNameError: true,
              cardLastNameError: true,
              recaptchaTokenError: true,
            },
          });
        }
        await this.verifyEmail();
        await this.isValidSignup();
        id === 1
          ? this.props.getPageDataFooter(7)
          : this.props.getPageDataFooter(6);
        this.props.clearDataEmail();
        localStorage.clear();
        this.props.clearSignupData();
        localStorage.setItem(
          "userTypeFooter",
          id === 1 ? "Business-User" : "Consumer"
        );
        await GetAllAffiliateUsersByAffiliateType(
          id === 1 ? "Business" : "Consumer"
        );
      }
    );
  };

  AckOnchangeCheckbox = (name, checked) => {
    let value = "";
    if (name === "cNotification" && checked === true) {
      value = "1";
    }
    if (name === "cUpdateClaim" && checked === true) {
      value = "1";
    }
    if (name === "cTermsandCondition" && checked === true) {
      value = "1";
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.isValidSignup();
        // console.log('sssssssssssssssssss tests', this.state)
      }
    );
    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  };

  _cSince(e) {
    this.setState({ cSince: e.value }, () => {
      this.isValidConsumer("cSince");
    });
  }

  _cSinceAdds(e) {
    this.setState({ cOptionsSinceAdds: e.value }, () => {
      this.isValidConsumer("cOptionsSinceAdds");
    });
  }

  AckOnchangeText = (e) => {
    let value = "";
    if (e.target.name === "cClaimUpdateText" && e.target.checked === true) {
      value = "1";
    }
    this.setState({
      [e.target.name]: value,
    });
  };

  handleSaveDataNext = async () => {
    const { isConsumer, password, planName, connectFusebill } = this.state;
    if (isConsumer) {
      await this.setState({
        cPassword: password,
        isLoader: true,
      });
      //       let consumerPlanPriceId = this.props.data.AllPlansForMember.records
      //  .Consumer[0].planPriceDto[0].planPriceId;
      // console.log('consumerPlanPriceId', consumerPlanPriceId);
      // this.setState({
      //   consumerPlanPriceId: consumerPlanPriceId,
      // });
      await this.props.saveConsumerUser(this.state);
    } else if (planName === "Basic" || connectFusebill === 0) {
      await this.setState({ isLoader: true });
      await this.props.saveBusinessUserPatner(this.state);
    } else {
      this.setState((prevState) => ({
        tabValue: 4,
        activeTab3: true,
        recaptchaToken: "",
        cardErrors: {
          ...prevState.cardErrors,
          recaptchaTokenError: true,
        },
      }));
    }

    this.setState({
      legalTabFilled: true,
    });

    await window.scrollTo(0, 0);
  };

  topScreen = () => {
    // const intervalId = setInterval(
    //   this.scrollStep.bind(this),
    //   this.props.delayInMs
    // );
    // this.setState({ intervalId });
  };

  ltrim = (str) => {
    if (!str) return str;
    return str.replace(/^\s+/g, "");
  };
  selectPricePlainDetail = (
    planPriceId,
    selectedPlanAmount,
    duration,
    durationType,
    fusebillPlanId,
    fusebillPlanFrequencyId,
    connectFusebill,
    durationCheckout,
    discountCheckout
  ) => {
    console.log("duration", connectFusebill);
    this.setState(
      {
        planPriceId,
        selectedPlanAmount,
        durationData: `${durationType} ${
          duration === "Month" ? "Month" : "year"
        }`,
        fusebillPlanId,
        fusebillPlanFrequencyId,
        connectFusebill,
        durationCheckout,
        discountCheckout,
      },
      () => {
        this.isValidCardDetail("");
      }
    );
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  backClick() {
    const { isConsumer } = this.state;
    if (isConsumer) {
      this.setState((state) => ({
        tabValueConsumer: 1,
      }));
    } else {
      this.setState((state) => ({
        tabValue: 2,
      }));
    }
    window.scrollTo(0, 0);
  }

  backClickSignature = () => {
    this.setState({
      IsSignatureForm: false,
    });
    window.scrollTo(0, 0);
  };

  _citySelect(e) {
    this.setState({ cityId: e.value });
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  _countrySelectWork(e) {
    this.setState({ workCountryCode: e.value });
  }

  viewPassword() {
    if (this.state.passwordType === "password") {
      this.setState({ passwordType: "text" });
    } else {
      this.setState({ passwordType: "password" });
    }
  }

  _cSince1(e) {
    this.setState({ startingYear: e.value }, () => {
      this.isValidSignup1("startingYear");
    });
  }

  componentDidMount() {
    const { GetAllAffiliateUsersByAffiliateType } = this.props;
    const { defaultIndex } = this.state;
    const AuthInfo = localStorage.getItem("user");
    const roleName = localStorage.getItem("roleName");
    const loginStatus = localStorage.getItem("loginStatus");

    if (AuthInfo) {
      if (roleName === "Affiliate" || roleName === "Affiliate-SubUser") {
        this.context.router.history.push("/affiliate");
      } else {
        if (loginStatus === "error") {
          this.context.router.history.push("/profile-terms");
        } else {
          this.context.router.history.push("/dashboard");
        }
      }
    }

    scroll.scrollToTop();
    this.props.getPageDataFooter(7);
    //  this.setState({
    //    intervalId1: 0,
    //  });
    GetAllAffiliateUsersByAffiliateType(
      defaultIndex === 1 ? "Business" : "Consumer"
    );

    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
        {
          const dataB = {
            lookupTypeId: 1,
          };
          const dataI = {
            lookupTypeId: 2,
          };

          this.props.getAllStates();
          this.props.getAllCountry();
          this.props.getAllPlans({
            pageNumber: 0,
            pageSize: 20,
            searchKeyword: "",
            planUserType: "Business",
            userId: 0,
            affiliateKey:
              this.props.match.params.affiliateKey !== undefined
                ? this.props.match.params.affiliateKey
                : "",
          });
          this.props.getBusiness(dataB);
          this.props.getIndustry(dataI);
        }
      }
    });
  }

  async componentWillMount() {
    const affiliateKeyId = this.props.match.params.affiliateKey;
    if (affiliateKeyId !== "" && affiliateKeyId !== undefined) {
      this.setState({ indexType: "selectedIndex", isLoaderDataSave: true });
      await this.props.getAffiliateDetailByAffiliateKey(affiliateKeyId);
    }
    this.setState({ affiliateKeyId });

    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  }

  _onSelect(e) {
    const { AllStates } = this.props.data;
    this.setState(
      {
        state: e.target.value,
        stateNameCard: AllStates[
          AllStates.findIndex(
            (data) => data.stateId === parseInt(e.target.value, 10)
          )
        ]
          ? AllStates[
              AllStates.findIndex(
                (data) => data.stateId === parseInt(e.target.value, 10)
              )
            ].stateName
          : "",
      },
      () => {
        this.isValid("state");
      }
    );
  }

  _onSelectCard(e) {
    const { AllStates } = this.props.data;
    this.setState(
      {
        stateCard: e.target.value,
        stateNameCard: AllStates[
          AllStates.findIndex(
            (data) => data.stateId === parseInt(e.target.value, 10)
          )
        ]
          ? AllStates[
              AllStates.findIndex(
                (data) => data.stateId === parseInt(e.target.value, 10)
              )
            ].stateName
          : "",
      },
      () => {
        this.isValidCardDetail("stateCard");
      }
    );
  }

  onSelectState = (e) => {
    this.setState({ cState: e.target.value }, () => {
      this.isValidConsumer("cState");
    });
  };

  _onSelectForBusiness(e) {
    this.setState({ businessTypeId: e.value });
  }

  _onSelectForYears(e) {
    this.setState({ industryTypeId: e.value }, () => {
      this.isValidSignup1("industryTypeId");
    });
  }

  onChangeTaxId(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      if (Number.parseInt(e.target.value, 10) !== 0 || e.target.value === "") {
        this.setState(
          {
            [e.target.name]: e.target.value,
            errorsTermPolicy: {},
            errorsCompany: {},
          },
          () => {
            this.isValid("totalTaxId");
          }
        );
      }
    }
  }

  onChange = async (e) => {
    // const { IsSignaUpForm1 } = this.state;
    const targetName = e.target.name;
    // console.log('ssssssssss', targetName, e.target.value)

    await this.setState(
      {
        [e.target.name]: e.target.value.trimLeft(),
        errorsTermPolicy: {},
        errorsCompany: {},
      },
      async () => {
        await this.isValid(targetName);
      }
    );

    //  await this.isValidSignup();
    // console.log('ssssssssss', e.target.name)
    // this.isValid(e.target.name);
    //   if (IsSignaUpForm1) {
    //     await   this.isValidSignup1();
    //   }

    // if (e.target.name === "separateTaxId") {
    //   if (e.target.value === "no") {
    //     this.setState({ totalTaxId: 0 });
    //   } else {
    //     this.setState({ totalTaxId: 1 });
    //   }
    // }
  };

  onChangePassword = async (e) => {
    const { IsSignaUpForm1 } = this.state;
    this.setState(
      {
        [e.target.name]: e.target.value,
        errorsTermPolicy: {},
        errorsCompany: {},
      },
      () => {
        this.isValidSignup();
        // this.isValid();
        if (IsSignaUpForm1) {
          this.isValidSignup1();
        }
      }
    );

    //  this.setState({ [e.target.name]: e.target.value }, () => { if (this.state.email !== '') { this.props.checkEmailVerify({ email: this.state.email }); } });
    if (e.target.name === "password") {
      const numberRegex = new RegExp("[0-9]");
      const specialCaseRegex = new RegExp("^(?=.*[!@#$%^&*])");
      const uperCaseRegex = new RegExp("[A-Z]");
      const lowerCaseRegex = new RegExp("[a-z]");
      this.setState({
        errorLowerCasePassword: lowerCaseRegex.test(e.target.value),
      });
      this.setState({
        errorUpperCasePassword: uperCaseRegex.test(e.target.value),
      });
      this.setState({ errorNumberPassword: numberRegex.test(e.target.value) });
      this.setState({
        errorSpecialPassword: specialCaseRegex.test(e.target.value),
      });
      this.setState({ errorLimitPassword: e.target.value.length > 7 });
    }

    this.setState({ passwordColor: "black" });
  };

  onChangeCarad = (e) => {
    let labelName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value.trimLeft(),
      },
      () => {
        this.isValidCardDetail(labelName);
      }
    );
  };

  isValidCardDetail(label) {
    const { errors, errorsState, isValid } = this.validateInputCard(
      this.state,
      label
    );
    // console.log('errors')
    // if (!isValid) {
    this.setState({ cardErrors: errors, cardErrorsState: errorsState });
    // }
    return isValid;
  }

  validateInputCard(data, label) {
    const { cardErrorsState } = this.state;
    const errors = cardErrorsState;
    const d = new Date();

    // const scrollViews = [];
    switch (label) {
      case "cardNumber":
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }
        break;

      case "cardFirstName":
        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }
        break;
      case "cardLastName":
        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }
        break;
      case "cardAddress":
        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters ";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }
        break;
      case "cardCity":
        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        break;

      case "stateCard":
        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }
        break;

      case "cardZipCode":
        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
        ) {
          errors.cardZipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        break;
      case "cardCvv":
        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }
        break;
      case "cardYear":
        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d.getFullYear().toString().substr(-2) * 1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          if (
            data.cardYear.replace(/_/g, "").toString() ===
            (d.getFullYear().toString().substr(-2) * 1).toString()
          ) {
            if (
              parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()
            ) {
              errors.cardMonth =
                "Expiration Month should be equal to or greater than the current month";
              errors.cardMonthError = true;
            }
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
          errors.cardYear = "";
          errors.cardYearError = false;
        }
        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (d.getFullYear().toString().substr(-2) * 1).toString()
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
      case "cardMonth":
        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) <= 0 ||
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12
        ) {
          errors.cardMonth = "Month should be between 1 to 12";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardYear.replace(/_/g, ""), 10) ===
          Number.parseInt(
            (d.getFullYear().toString().substr(-2) * 1).toString(),
            10
          )
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        } else {
          errors.cardMonth = "";
          errors.cardMonthError = false;
        }
        break;
      case "":
        break;
      case "cardAddress2":
        break;
      case "recaptchaToken":
        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }
        break;
      default:
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }

        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }

        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }

        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }

        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }

        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }

        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
        ) {
          errors.cardZipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12 ||
          parseInt(data.cardMonth.replace(/_/g, ""), 10) === 0
        ) {
          errors.cardMonth = "Expiry Month should be equal to two numbers";
          errors.cardMonthError = true;
        }

        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }

        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d.getFullYear().toString().substr(-2) * 1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          errors.cardYear = "";
          errors.cardYearError = false;
        }

        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (d.getFullYear().toString().substr(-2) * 1).toString()
        ) {
          if (
            parseInt(data.cardMonth.replace(/_/g, ""), 10) <
            parseInt(d.getMonth().toString(), 10)
          ) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
    }

    // console.log('ssssssss',errors)

    return {
      errorsState: errors,
      errors:
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
          ? {}
          : errors,
      isValid: !(
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
      ),
    };
  }

  cardOnChange = () => {
    const {
      sameAddress,
      firstName,
      lastName,
      streeAddress,
      city,
      zipCode,
      state,
      streeAddress2,
    } = this.state;
    this.setState(
      {
        sameAddress: !sameAddress,
        cardFirstName: !sameAddress ? `${firstName}` : "",
        cardLastName: !sameAddress ? `${lastName}` : "",
        cardAddress: !sameAddress ? streeAddress : "",
        cardAddress2: !sameAddress ? streeAddress2 : "",
        cardCity: !sameAddress ? city : "",
        cardZipCode: !sameAddress ? zipCode : "",
        stateCard: !sameAddress ? state : "",
      },
      () => {
        this.isValidCardDetail();
      }
    );
  };

  onChangeEmail = (e) => {
    this.setState(
      {
        email: e.target.value,
        cEmail: e.target.value,
      },
      async () => {
        await this.verifyEmail();
        await this.isValidSignup();
      }
    );
  };

  onChange1(e) {
    this.setState({ passwordColor: "black" });
    const labelName = e.target.name;
    //  const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    //  if (re.test(e.target.value) || e.target.value === '') {
    this.setState({ [e.target.name]: e.target.value.trimLeft() }, () => {
      this.isValidConsumer(labelName);
    });
    //  }
  }

  isValid(e) {
    const { bussnessSigUpError, errors, isValid } = this.validateInput(
      this.state,
      e
    );
    // if (!isValid) {
    this.setState({ errors, bussnessSigUpErrorStatus: bussnessSigUpError });
    // }

    return !isValid;
  }

  isValidSignup() {
    const { errorsSignup, isValid } = this.validateInputSignup(this.state);
    // if (!isValid) {
    // console.log('errorsSignup', errorsSignup)
    this.setState({ errorsSignup });
    // }
    return isValid;
  }

  isValidSignup1(label) {
    const { errorsSignupPlan, isValid } = this.validateInputSignupPlain(
      this.state,
      label
    );
    // if (!isValid) {
    this.setState({ errorsSignupPlan });
    // }
    return isValid;
  }

  validateInputSignup(data) {
    const {
      errorNumberPassword,
      errorUpperCasePassword,
      errorLimitPassword,
      errorSpecialPassword,
      errorLowerCasePassword,
      // cNotification,
      cTermsandCondition,
      cUpdateClaim,
      isConsumer,
    } = this.state;
    const errorsSignup = {};
    const scrollViews = [];

    if (!Validator.isEmail(data.email)) {
      // errorsSignup.email = 'Email is Not Valid';
      errorsSignup.emailError = true;
      // scrollViews.push(this.emailRef);
    }
    if (Validator.isEmpty(data.email)) {
      // errorsSignup.email = 'Email is required';
      errorsSignup.emailError = true;
      // scrollViews.push(this.emailRef);
    }

    if (Validator.isEmpty(data.password)) {
      errorsSignup.passwordError = true;
      // errorsSignup.password = 'Password is required';
      scrollViews.push(this.passwordRef);
    }
    const re = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    if (!re.test(data.password)) {
      this.setState({ passwordColor: "red" });
      errorsSignup.passwordError = true;
      scrollViews.push(this.passwordRef);
    }

    if (scrollViews.length > 0) {
      scrollToComponent(scrollViews[0], {
        offset: 200,
        align: "bottom",
        duration: 500,
        ease: "inExpo",
      });
    }
    if (!errorLowerCasePassword) {
      errorsSignup.passwordError = true;
    }
    if (isConsumer) {
      // if (cNotification !== '1') {
      //   errorsSignup.passwordError = true;
      // }
      if (cTermsandCondition !== "1") {
        errorsSignup.passwordError = true;
      }
      if (cUpdateClaim !== "1") {
        errorsSignup.passwordError = true;
      }
    }

    if (!errorUpperCasePassword) {
      errorsSignup.passwordError = true;
    }

    if (!errorLimitPassword) {
      errorsSignup.passwordError = true;
    }

    if (!errorSpecialPassword) {
      errorsSignup.passwordError = true;
    }

    if (!errorNumberPassword) {
      errorsSignup.passwordError = true;
    }

    if (!errorNumberPassword) {
      errorsSignup.passwordError = true;
    }

    // console.log('errorsSignup', errorsSignup)
    return {
      errorsSignup,
      isValid: isEmpty(errorsSignup),
    };
  }

  validateInputSignupPlain(data, label) {
    const { errorsSignupPlanStatus } = this.state;
    const errorsSignupPlan = errorsSignupPlanStatus;
    const scrollViews = [];
    const webSiteRe = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;

    switch (label) {
      case "industryTypeId":
        if (!data.industryTypeId) {
          errorsSignupPlan.industryTypeId = "Industry is required";
          errorsSignupPlan.industryTypeIdError = true;
          // scrollViews.push(this.IndustryDataoptionsRef);
        } else {
          errorsSignupPlan.industryTypeId = "";
          errorsSignupPlan.industryTypeIdError = false;
        }
        if (data.industryTypeId === 119) {
          if (!data.otherIndustryType) {
            errorsSignupPlan.otherIndustryType =
              "Other industry type is required";
            errorsSignupPlan.otherIndustryTypeError = true;
            // otherIndustryType
          } else {
            errorsSignupPlan.otherIndustryType = "";
            errorsSignupPlan.otherIndustryTypeError = false;
          }
        } else {
          errorsSignupPlan.otherIndustryType = "";
          errorsSignupPlan.otherIndustryTypeError = false;
        }
        break;
      case "startingYear":
        if (!data.startingYear) {
          errorsSignupPlan.startingYear = "Starting year is required";
          errorsSignupPlan.startingYearError = true;
        } else {
          errorsSignupPlan.startingYear = "";
          errorsSignupPlan.startingYearError = false;
        }
        break;
      case "otherIndustryType":
        if (data.industryTypeId === 119) {
          if (!data.otherIndustryType) {
            errorsSignupPlan.otherIndustryType =
              "Other industry type is required";
            errorsSignupPlan.otherIndustryTypeError = true;
            // otherIndustryType
          } else {
            errorsSignupPlan.otherIndustryType = "";
            errorsSignupPlan.otherIndustryTypeError = false;
          }
        } else {
          errorsSignupPlan.otherIndustryType = "";
          errorsSignupPlan.otherIndustryTypeError = false;
        }

        break;

      case "webSite":
        if (data.webSite !== "") {
          if (!webSiteRe.test(data.webSite)) {
            errorsSignupPlan.webSite = "Invalid url";
            errorsSignupPlan.webSiteError = true;
            scrollViews.push(this.webSiteRef);
            //  }
          } else {
            errorsSignupPlan.webSite = "";
            errorsSignupPlan.webSiteError = false;
          }
        } else {
          errorsSignupPlan.webSite = "";
          errorsSignupPlan.webSiteError = false;
        }

        break;

      case "enterpriseType":
        if (!data.enterpriseType) {
          // errorsSignupPlan.enterpriseType = 'Please choose the size of your company';
          errorsSignupPlan.enterpriseTypeError = true;
        } else {
          errorsSignupPlan.enterpriseTypeError = false;
        }
        break;

      // case 'taxId':
      //   if (!data.taxId) {
      //     errors.taxId = 'Tax Id is required';
      //     errors.taxIdError = true;
      //     scrollViews.push(this.taxIdRef);
      //   } else if (
      //     data.taxId.replace(/\s/g, '').replace(/[_-]/g, '').length !== 9
      //   ) {
      //     errors.taxId = 'Please enter at least 9 digit';
      //     errors.taxIdError = true;
      //     scrollViews.push(this.taxIdRef);
      //   break;

      case 'acceptCC':
        if (!data.acceptCC) {
          // errorsSignupPlan.acceptCC = 'Company Credit Cards is required';
          errorsSignupPlan.acceptCCError = true;
          scrollViews.push(this.bottomDownRef);
        } else {
          errorsSignupPlan.acceptCCError = false;
        }

        break;

      case "bankruptcyStatus":
        if (!data.bankruptcyStatus) {
          // errorsSignupPlan.bankruptcyStatus = 'Bankruptcy is required';
          errorsSignupPlan.bankruptcyStatusError = true;
          // scrollViews.push(this.bottomDownRef);
        } else {
          errorsSignupPlan.bankruptcyStatusError = false;
        }

        break;

      case "dissolvedStatus":
        if (!data.dissolvedStatus) {
          // errorsSignupPlan.dissolvedStatus = 'Dissolve is required';
          errorsSignupPlan.dissolvedStatusError = true;
          scrollViews.push(this.bottomDownRef2);
        } else {
          errorsSignupPlan.dissolvedStatusError = false;
        }

        break;

      default:
        if (data.webSite !== "") {
          if (!webSiteRe.test(data.webSite)) {
            errorsSignupPlan.webSite = "Invalid url";
            errorsSignupPlan.webSiteError = true;
            scrollViews.push(this.webSiteRef);
            //  }
          } else {
            errorsSignupPlan.webSite = "";
            errorsSignupPlan.webSiteError = false;
          }
        } else {
          errorsSignupPlan.webSite = "";
          errorsSignupPlan.webSiteError = false;
        }

        if (!data.industryTypeId) {
          errorsSignupPlan.industryTypeId = "Industry is required";
          errorsSignupPlan.industryTypeIdError = true;
          // scrollViews.push(this.IndustryDataoptionsRef);
        } else {
          errorsSignupPlan.industryTypeId = "Industry is required";
          errorsSignupPlan.industryTypeIdError = false;
        }
        if (!data.bankruptcyStatus) {
          // errorsSignupPlan.bankruptcyStatus = 'Bankruptcy is required';
          errorsSignupPlan.bankruptcyStatusError = true;
          // scrollViews.push(this.bottomDownRef);
        } else {
          errorsSignupPlan.bankruptcyStatusError = false;
        }

        if (!data.acceptCC) {
          // errorsSignupPlan.acceptCC = 'Company Credit Cards is required';
          errorsSignupPlan.acceptCCError = true;
          scrollViews.push(this.bottomDownRef);
        } else {
          errorsSignupPlan.acceptCCError = false;
        }

        if (!data.enterpriseType) {
          // errorsSignupPlan.enterpriseType = 'Please choose the size of your company';
          errorsSignupPlan.enterpriseTypeError = true;
        } else {
          errorsSignupPlan.enterpriseTypeError = false;
        }

        if (!data.dissolvedStatus) {
          // errorsSignupPlan.dissolvedStatus = 'Dissolve is required';
          errorsSignupPlan.dissolvedStatusError = true;
          scrollViews.push(this.bottomDownRef2);
        } else {
          errorsSignupPlan.dissolvedStatusError = false;
        }

        if (!data.startingYear) {
          errorsSignupPlan.startingYear = "Starting year is required";
          errorsSignupPlan.startingYearError = true;
        } else {
          errorsSignupPlan.startingYear = "";
          errorsSignupPlan.startingYearError = false;
        }
        // if (scrollViews.length > 0) {
        //   scrollToComponent(scrollViews[0], {
        //     offset: 200,
        //     align: "bottom",
        //     duration: 500,
        //     ease: "inExpo"
        //   });
        // }

        if (data.industryTypeId === 119) {
          if (!data.otherIndustryType) {
            errorsSignupPlan.otherIndustryType =
              "Other industry type is required";
            errorsSignupPlan.otherIndustryTypeError = true;
            // otherIndustryType
          } else {
            errorsSignupPlan.otherIndustryType = "";
            errorsSignupPlan.otherIndustryTypeError = false;
          }
        } else {
          errorsSignupPlan.otherIndustryType = "";
          errorsSignupPlan.otherIndustryTypeError = false;
        }

        break;
    }

    // console.log('sssssssss', data, errorsSignupPlan)
    return {
      errorsSignupPlan:
        errorsSignupPlan.webSiteError === false &&
        errorsSignupPlan.industryTypeIdError === false &&
        errorsSignupPlan.bankruptcyStatusError === false &&
        errorsSignupPlan.acceptCCError === false &&
        errorsSignupPlan.enterpriseTypeError === false &&
        errorsSignupPlan.startingYearError === false &&
        errorsSignupPlan.dissolvedStatusError === false &&
        errorsSignupPlan.otherIndustryTypeError === false
          ? {}
          : errorsSignupPlan,
      isValid:
        errorsSignupPlan.webSiteError === false &&
        errorsSignupPlan.industryTypeIdError === false &&
        errorsSignupPlan.bankruptcyStatusError === false &&
        errorsSignupPlan.acceptCCError === false &&
        errorsSignupPlan.enterpriseTypeError === false &&
        errorsSignupPlan.startingYearError === false &&
        errorsSignupPlan.dissolvedStatusError === false &&
        errorsSignupPlan.otherIndustryTypeError === false,
    };
  }

  validateInput(data, e) {
    const { bussnessSigUpErrorStatus } = this.state;
    let errors = bussnessSigUpErrorStatus;
    const scrollViews = [];
    switch (e) {
      case "firstName":
        if (!data.firstName.trim()) {
          errors.firstName = "First name is required";
          errors.firstNameError = true;
          scrollViews.push(this.firstNameRef);
        } else if (
          data.firstName.trim().length < 2 ||
          data.firstName.trim().length > 20
        ) {
          errors.firstName =
            "First name should consist of min 2 and max 20 characters";
          errors.firstNameError = true;
          scrollViews.push(this.firstNameRef);
        } else {
          errors.firstName = "";
          errors.firstNameError = false;
        }
        break;

      case "lastName":
        if (!data.lastName) {
          errors.lastName = "Last name is required";
          errors.lastNameError = true;
          scrollViews.push(this.lastNameRef);
        } else if (data.lastName.length < 2 || data.lastName.length > 30) {
          errors.lastName =
            "Last name should consist of min 2 and max 30 characters";
          errors.lastNameError = true;
          scrollViews.push(this.lastNameRef);
        } else {
          errors.lastName = "";
          errors.lastNameError = false;
        }
        break;

      case "nonWorkPhoneNumber":
        if (!data.nonWorkPhoneNumber) {
          errors.nonWorkPhoneNumber = "Mobile phone number is required";
          errors.nonWorkPhoneNumberError = true;
          scrollViews.push(this.newMobilePhoneRef);
        } else if (
          data.nonWorkPhoneNumber.replace(/\s/g, "").replace(/[_-]/g, "")
            .length !== 10
        ) {
          errors.nonWorkPhoneNumber = "Please provide a valid phone number";
          errors.nonWorkPhoneNumberError = true;
        } else {
          errors.nonWorkPhoneNumber = "";
          errors.nonWorkPhoneNumberError = false;
        }
        break;

      case "workPhoneNumber":
        if (!data.workPhoneNumber) {
          errors.workPhoneNumber = "Work phone number is required";
          errors.workPhoneNumberError = true;
          scrollViews.push(this.workPhoneNumberRef);
        } else if (
          data.workPhoneNumber.replace(/\s/g, "").replace(/[_-]/g, "")
            .length !== 10
        ) {
          errors.workPhoneNumber = "Please provide a valid phone number";
          errors.workPhoneNumberError = true;
          scrollViews.push(this.workPhoneNumberRef);
        } else {
          errors.workPhoneNumber = "";
          errors.workPhoneNumberError = false;
        }
        break;
      case "companyTitle":
        if (!data.companyTitle) {
          errors.companyTitle = "Title is required";
          errors.companyTitleError = true;
          scrollViews.push(this.companyTitleRef);
        } else if (
          data.companyTitle.length < 2 ||
          data.companyTitle.length > 20
        ) {
          errors.companyTitle =
            "Title/Position should consist of min 2 and max 20 characters";
          errors.companyTitleError = true;
          scrollViews.push(this.companyTitleRef);
        } else {
          errors.companyTitle = "";
          errors.companyTitleError = false;
        }
        break;
      case "companyName":
        if (Validator.isEmpty(data.companyName)) {
          errors.companyName = "Company name is required";
          errors.companyNameError = true;
          scrollViews.push(this.companyNameRef);
        } else if (
          data.companyName.length < 2 ||
          data.companyName.length > 50
        ) {
          errors.companyName =
            "Company name and DBA should consist of min 2 and max 50 characters";
          errors.companyNameError = true;
          scrollViews.push(this.companyNameRef);
        } else {
          errors.companyName = "";
          errors.companyNameError = false;
        }
        break;

      case "streeAddress":
        if (Validator.isEmpty(data.streeAddress)) {
          errors.streeAddress = "Address is required";
          errors.streeAddressError = true;
          scrollViews.push(this.streeAddressRef);
        } else if (
          data.streeAddress.length < 2 ||
          data.streeAddress.length > 50
        ) {
          errors.streeAddress =
            "Street address should consist of min 2 and max 50 characters";
          errors.streeAddressError = true;
          scrollViews.push(this.streeAddressRef);
        } else {
          errors.streeAddress = "";
          errors.streeAddressError = false;
        }
        break;
      case "city":
        if (!data.city) {
          errors.city = "City is required";
          errors.cityError = true;
          scrollViews.push(this.cityRef);
        } else if (data.city.length < 2 || data.city.length > 30) {
          errors.city = "City should consist of min 2 and max 30 characters";
          errors.cityError = true;
          scrollViews.push(this.cityRef);
        } else {
          errors.city = "";
          errors.cityError = false;
        }
        break;
      case "state":
        if (!data.state) {
          errors.state = "State is required";
          errors.stateError = true;
          scrollViews.push(this.stateRef);
        } else {
          errors.state = "";
          errors.stateError = false;
        }
        break;
      case "zipCode":
        if (!data.zipCode) {
          errors.zipCode = "Zip code is required";
          errors.zipCodeError = true;
          scrollViews.push(this.zipCodeRef);
        } else if (
          data.zipCode.replace(/\s/g, "").replace(/[_-]/g, "").length < 2
        ) {
          errors.zipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.zipCodeError = true;
          scrollViews.push(this.zipCodeRef);
        } else {
          errors.zipCode = "";
          errors.zipCodeError = false;
        }
        break;

      case "taxId":
        if (!data.taxId) {
          errors.taxId = "Tax Id is required";
          errors.taxIdError = true;
          scrollViews.push(this.taxIdRef);
        } else if (
          data.taxId.replace(/\s/g, "").replace(/[_-]/g, "").length !== 9
        ) {
          errors.taxId = "Please enter at least 9 digit";
          errors.taxIdError = true;
          scrollViews.push(this.taxIdRef);
        } else {
          errors.taxId = "";
          errors.taxIdError = false;
        }

        break;
      case "separateTaxId":
        if (data.separateTaxId === "") {
          // errors.separateTaxId = 'Please enter at least 9 digit';
          errors.separateTaxIdError = true;
        } else {
          errors.separateTaxIdError = false;
        }
        if (data.separateTaxId !== "") {
          if (data.totalTaxId === "") {
            errors.totalTaxId = "EINs is required";
            errors.totalTaxIdError = true;
          } else {
            errors.totalTaxId = "";
            errors.totalTaxIdError = false;
          }
        }
        if (data.separateTaxId !== "") {
          if (data.totalTaxId === "") {
            errors.totalTaxId = "EINs is required";
            errors.totalTaxIdError = true;
          } else {
            errors.totalTaxId = "";
            errors.totalTaxIdError = false;
          }
        }

        break;
      case "totalTaxId":
        if (data.separateTaxId !== "") {
          if (data.totalTaxId === "") {
            errors.totalTaxId = "EINs is required";
            errors.totalTaxIdError = true;
          } else {
            errors.totalTaxId = "";
            errors.totalTaxIdError = false;
          }
        }
        break;
      case "streeAddress2":
        break;

      default:
        if (!data.firstName.trim()) {
          errors.firstName = "First name is required";
          errors.firstNameError = true;
          scrollViews.push(this.firstNameRef);
        } else if (
          data.firstName.trim().length < 2 ||
          data.firstName.trim().length > 20
        ) {
          errors.firstName =
            "First name should consist of min 2 and max 20 characters";
          errors.firstNameError = true;
          scrollViews.push(this.firstNameRef);
        } else {
          errors.firstName = "";
          errors.firstNameError = false;
        }

        if (!data.lastName) {
          errors.lastName = "Last name is required";
          errors.lastNameError = true;
          scrollViews.push(this.lastNameRef);
        } else if (data.lastName.length < 2 || data.lastName.length > 30) {
          errors.lastName =
            "Last name should consist of min 2 and max 30 characters";
          errors.lastNameError = true;
          scrollViews.push(this.lastNameRef);
        } else {
          errors.lastName = "";
          errors.lastNameError = false;
        }

        if (!data.nonWorkPhoneNumber) {
          errors.nonWorkPhoneNumber = "Mobile phone number is required";
          errors.nonWorkPhoneNumberError = true;
          scrollViews.push(this.newMobilePhoneRef);
        } else if (
          data.nonWorkPhoneNumber.replace(/\s/g, "").replace(/[_-]/g, "")
            .length !== 10
        ) {
          errors.nonWorkPhoneNumber = "Please provide a valid phone number";
          errors.nonWorkPhoneNumberError = true;
        } else {
          errors.nonWorkPhoneNumber = "";
          errors.nonWorkPhoneNumberError = false;
        }

        if (!data.workPhoneNumber) {
          errors.workPhoneNumber = "Work phone number is required";
          errors.workPhoneNumberError = true;
          scrollViews.push(this.workPhoneNumberRef);
        } else if (
          data.workPhoneNumber.replace(/\s/g, "").replace(/[_-]/g, "")
            .length !== 10
        ) {
          errors.workPhoneNumber = "Please provide a valid phone number";
          errors.workPhoneNumberError = true;
          scrollViews.push(this.workPhoneNumberRef);
        } else {
          errors.workPhoneNumber = "";
          errors.workPhoneNumberError = false;
        }

        if (!data.companyTitle) {
          errors.companyTitle = "Title is required";
          errors.companyTitleError = true;
          scrollViews.push(this.companyTitleRef);
        } else if (
          data.companyTitle.length < 2 ||
          data.companyTitle.length > 20
        ) {
          errors.companyTitle =
            "Title/Position should consist of min 2 and max 20 characters";
          errors.companyTitleError = true;
          scrollViews.push(this.companyTitleRef);
        } else {
          errors.companyTitle = "";
          errors.companyTitleError = false;
        }

        if (Validator.isEmpty(data.companyName)) {
          errors.companyName = "Company name is required";
          errors.companyNameError = true;
          scrollViews.push(this.companyNameRef);
        } else if (
          data.companyName.length < 2 ||
          data.companyName.length > 50
        ) {
          errors.companyName =
            "Company name and DBA should consist of min 2 and max 50 characters";
          errors.companyNameError = true;
          scrollViews.push(this.companyNameRef);
        } else {
          errors.companyName = "";
          errors.companyNameError = false;
        }

        if (Validator.isEmpty(data.streeAddress)) {
          errors.streeAddress = "Address is required";
          errors.streeAddressError = true;
          scrollViews.push(this.streeAddressRef);
        } else if (
          data.streeAddress.length < 2 ||
          data.streeAddress.length > 50
        ) {
          errors.streeAddress =
            "Street address should consist of min 2 and max 50 characters";
          errors.streeAddressError = true;
          scrollViews.push(this.streeAddressRef);
        } else {
          errors.streeAddress = "";
          errors.streeAddressError = false;
        }

        if (!data.city) {
          errors.city = "City is required";
          errors.cityError = true;
          scrollViews.push(this.cityRef);
        } else if (data.city.length < 2 || data.city.length > 30) {
          errors.city = "City should consist of min 2 and max 30 characters";
          errors.cityError = true;
          scrollViews.push(this.cityRef);
        } else {
          errors.city = "";
          errors.cityError = false;
        }

        if (!data.state) {
          errors.state = "State is required";
          errors.stateError = true;
          scrollViews.push(this.stateRef);
        } else {
          errors.state = "";
          errors.stateError = false;
        }

        // console.log('data.zipCode', errors, data.zipCode.replace(/\s/g, '').replace(/[_-]/g, ''))
        if (!data.zipCode) {
          errors.zipCode = "Zip code is required";
          errors.zipCodeError = true;
          scrollViews.push(this.zipCodeRef);
        } else if (
          data.zipCode.replace(/\s/g, "").replace(/[_-]/g, "").length < 2
        ) {
          errors.zipCode =
            "Zip code should consist of min 2 and max 5 characters";
          errors.zipCodeError = true;
          scrollViews.push(this.zipCodeRef);
        } else {
          errors.zipCode = "";
          errors.zipCodeError = false;
        }

        if (!data.taxId) {
          errors.taxId = "Tax Id is required";
          errors.taxIdError = true;
          scrollViews.push(this.taxIdRef);
        } else if (
          data.taxId.replace(/\s/g, "").replace(/[_-]/g, "").length !== 9
        ) {
          errors.taxId = "Please enter at least 9 digit";
          errors.taxIdError = true;
          scrollViews.push(this.taxIdRef);
        } else {
          errors.taxId = "";
          errors.taxIdError = false;
        }

        if (data.separateTaxId === "") {
          // errors.separateTaxId = 'Please enter at least 9 digit';
          errors.separateTaxIdError = true;
        } else {
          errors.separateTaxIdError = false;
        }
        if (data.separateTaxId !== "") {
          if (data.totalTaxId === "") {
            errors.totalTaxId = "EINs is required";
            errors.totalTaxIdError = true;
          } else {
            errors.totalTaxId = "";
            errors.totalTaxIdError = false;
          }
        }

        break;
    }

    return {
      bussnessSigUpError: errors,
      errors:
        errors.firstNameError === false &&
        errors.lastNameError === false &&
        errors.nonWorkPhoneNumberError === false &&
        errors.workPhoneNumberError === false &&
        errors.companyTitleError === false &&
        errors.companyNameError === false &&
        errors.totalTaxIdError === false &&
        errors.streeAddressError === false &&
        errors.cityError === false &&
        errors.stateError === false &&
        errors.zipCodeError === false &&
        errors.taxIdError === false &&
        errors.separateTaxIdError === false
          ? {}
          : errors,
      isValid:
        (data,
        errors.firstNameError === false &&
          errors.lastNameError === false &&
          errors.nonWorkPhoneNumberError === false &&
          errors.workPhoneNumberError &&
          errors.companyTitleError === false &&
          errors.companyNameError === false &&
          errors.streeAddressError === false &&
          errors.cityError === false &&
          errors.stateError === false &&
          errors.zipCodeError === false &&
          errors.taxIdError === false &&
          errors.separateTaxIdError === false &&
          errors.totalTaxIdError === false),
      // isValid: isEmpty(errors)
    };
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { firstName, lastName } = this.state;
    // console.log('this.isValid()',this.isValid())

    if (this.isValid()) {
      await this.setState(
        {
          signatureDefaultValue: `${firstName} ${lastName}`,
          IsSignaUpForm1: true,
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  }

  handleSubmitSignup = async () => {
    const { isConsumer } = this.state;
    if (isConsumer) {
      window.scrollTo(0, 0);
      this.setState({
        tabValueConsumer: 1,
        activeTab1Consumer: true,
      });
    } else if (this.isValidSignup()) {
      window.scrollTo(0, 0);
      await this.setState({
        errorsSignup: {},
        tabValue: 1,
        activeTab1: true,
      });
    }
  };

  handleSubmitConsumer = () => {
    const { cFirstName, cLastName } = this.state;
    this.setState(
      {
        tabValueConsumer: 2,
        activeTab2Consumer: true,
        signatureDefaultValue: `${cFirstName} ${cLastName}`,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  async handleSubmitPlanPage(e) {
    e.preventDefault();
    if (this.isValidSignup1()) {
      await this.setState(
        {
          errorsSignupPlan: {},
          tabValue: 2,
          activeTab2: true,
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  }

  onPlanSelectBar(id, selectedPlanAmount, planData) {
    this.setState({
      planPriceId: id,
      selectedPlanAmount,
      selectedPlanName: planData.planName,
    });
    this.onPlanSelectSubmit();
  }

  onPlanSelect(e) {
    const id = e.value;
    this.setState({
      planPriceId: id,
    });
  }

  onPlanSelectSubmit() {
    const partnerType = this.props.match.params.partnerType;
    if (partnerType === "Both" || typeof partnerType === "undefined") {
      this.setState({
        IsCompanyForm: 4,
        defaultIndex: 1,
      });
      scrollToComponent(this.termsAndConditionsRef, {
        offset: 0,
        align: "bottom",
        duration: 500,
        ease: "inExpo",
      });
    } else if (partnerType === "Business") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 1,
      });
    } else if (partnerType === "Consumer") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 0,
      });
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async finalSubmit() {
    const { setPageName } = this.props;
    // this.setState({
    //   file: data.file,
    // }, () => {
    await this.setState({ isLoader: true });
    window.scrollTo(0, 0);
    await this.props.saveBusinessUserPatner(this.state);
    setPageName('signup');

    // });
  }

  fileImage = (data) => {
    this.setState({
      file: data,
    });
  };

  openModal() {
    this.setState({ modalIsOpen: true, fileError: false });
  }

  afterOpenModal() {}

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  fileChangedHandler = (event) => {
    this.setState({ file: event.target.files[0] });
  };

  codeOnSubmit(e) {
    e.preventDefault();

    if (this.state.code !== "") {
      this.props.confirmUserEmail(this.state);
    } else {
      const errors = {};
      errors.code = "Verification code is required";
      this.setState({
        errors,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  onItemClick = (id, selectedPlanAmount, planData) => {
    localStorage.setItem("selectedPlanAmount", selectedPlanAmount);
    this.props.onPlanSelect(id, selectedPlanAmount, planData);
    this.setState({
      modalIsOpenPlainPage1: false,
      modalIsOpenPlainPage: false,
    });
  };

  onItemPlanClick = (id, planName, planDetail) => {
    const {
      readUserAgreement,
      readLetterOfAgency,
      readPrivacyPolicy,
      readDisclaimer,
      fileData,
    } = this.state;

    // readUserAgreement === "1" &&
    // readLetterOfAgency === "1" &&
    // readPrivacyPolicy === "1" &&
    // readDisclaimer === "1" &&
    // fileData !== ""

    const tabValue =
      this.state.legalTabFilled === true && planName !== "Basic"
        ? readUserAgreement === "1" &&
          readLetterOfAgency === "1" &&
          readPrivacyPolicy === "1" &&
          readDisclaimer === "1" &&
          fileData !== ""
          ? 4
          : 3
        : 3;
    this.setState({
      planId: id,
      planName,
      selectedPlanName: planName,
      planPriceId: planDetail.planPriceDto[0].planPriceId,
      fusebillPlanId: planDetail.planPriceDto[0].fusebillPlanId,
      fusebillPlanFrequencyId:
        planDetail.planPriceDto[0].fusebillPlanFrequencyId,
      connectFusebill: planDetail.planPriceDto[0].connectFusebill,
      activeTab3: true,
      tabValue,
      selectedPlanAmount: planDetail.planPriceDto[0].subscriptionFees,
      durationData: "1 Month",
      // planPriceId: 0
    });
    window.scrollTo(0, 0);
  };

  async componentDidUpdate() {
    const { plansDataAffiliate, userInfo, AllPlansForMember } = this.props.data;

    // console.log("plansDataAffiliate", plansDataAffiliate, AllPlansForMember);

    // const { BusinessUserDataStep1 } = this.props;
    const {
      match: { params },
      // signupData: { BusinessUserDataStep1 }
    } = this.props;
    // const { BusinessUserDataStep1Data } = this.state;

    const plainDto = {};
    const {
      plansDataAffiliate1,
      AllPlansForMember1,
      userDataLogin1,
      planName,
      connectFusebill,
    } = this.state;

    if (userInfo !== undefined) {
      if (typeof userInfo.user !== "undefined") {
        if (userDataLogin1 !== userInfo) {
          localStorage.setItem("showTutorial", true);
          this.setState({
            userDataLogin1: userInfo,
          });
          let data;
          let planPriceId;
          if (this.props.match.params.affiliateKey !== undefined) {
            if (this.state.enterpriseType == "S") {
              planPriceId = this.props.data.plansDataAffiliate.result
                .affiliateSubscriptionDto.map.Small[0].planPriceDto[0]
                .planPriceId;
            } else if (this.state.enterpriseType == "E") {
              planPriceId = this.props.data.plansDataAffiliate.result
                .affiliateSubscriptionDto.map.Enterprise[0].planPriceDto[0]
                .planPriceId;
            }
          } else {
            if (this.state.enterpriseType == "S") {
              planPriceId = this.props.data.AllPlansForMember.records.Small[0]
                .planPriceDto[0].planPriceId;
            } else if (this.state.enterpriseType == "E") {
              planPriceId = this.props.data.AllPlansForMember.records
                .Enterprise[0].planPriceDto[0].planPriceId;
            }
          }
          data = {
            userId: localStorage.getItem("userId"),
            planPriceId,
            paymentStatus: "pending",
            selectedPlanName: "Basic",
            selectedPlanAmount: 0,
          };

          // If the fusebill payment status is paid. commited
          // if (localStorage.getItem('paymentStatus') === 'paid') {
          if (planName !== "Premium" && planName !== "Flex") {
            if (
              localStorage.getItem("connectFusebill") === "1" &&
              localStorage.getItem("plainNameDto") !== "Basic" &&
              localStorage.getItem("plainNameDto") !== "Basic Automatic"
            ) {
              if (
                this.props.data.fusebillData &&
                this.props.data.fusebillData.code === 400
              ) {
                // Todo Plan price change api
                await this.props.planPriceChange(data);
                // This parameter has been set in the localstorage because
                // there is no issue if hacker also set this param in local storage.
                // Because if he go to dashboard without payment even then he will be able to
                // access only free services.
                localStorage.setItem("paymentFailedButLetUserIn", true);
                this.setState({
                  failureModalStatus: true,
                  isLoader: false,
                });
              } else {
                this.setState({
                  successModalStatus: true,
                  isLoader: false,
                });
              }
            } else {
              this.context.router.history.push("/dashboard");
            }
            // this.context.router.history.push('/dashboard');
          } else {
            if (connectFusebill === 1) {
              if (
                this.props.data.fusebillData &&
                this.props.data.fusebillData.code === 400
              ) {
                // Todo Plan price change api
                await this.props.planPriceChange(data);
                // This parameter has been set in the localstorage because
                // there is no issue if hacker also set this param in local storage.
                // Because if he go to dashboard without payment even then he will be able to
                // access only free services.
                localStorage.setItem("paymentFailedButLetUserIn", true);
                this.setState({
                  failureModalStatus: true,
                  isLoader: false,
                });
              } else {
                this.setState({
                  successModalStatus: true,
                  isLoader: false,
                });
              }
            } else {
              this.context.router.history.push("/dashboard");
            }
          }
          // }
        }
      }
    }

    // if (userInfo !== undefined) {
    //   if (typeof userInfo.user !== "undefined") {
    //     if (userDataLogin1 !== userInfo) {
    //       this.setState({
    //         userDataLogin1: userInfo
    //       });
    //       console.log('userInfo',planName !== "Premium" && planName !== "Flex")
    //       // If the fusebill payment status is paid. commited
    //       // if (localStorage.getItem('paymentStatus') === 'paid') {
    //       if (planName !== "Premium" && planName !== "Flex") {
    //         if (localStorage.getItem("connectFusebill") !== '1') {
    //           this.context.router.history.push("/dashboard");
    //         } else {
    //           if (localStorage.getItem("plainNameDto") ==="Basic") {
    //             this.context.router.history.push("/dashboard");
    //           } else {
    //           this.setState({
    //             successModalStatus: true,
    //             iisLoader: false
    //           });
    //         }
    //         }
    //         // this.context.router.history.push("/dashboard");
    //       } else {
    //         if (connectFusebill === 1) {
    //           this.setState({
    //             successModalStatus: true,
    //             iisLoader: false
    //           });
    //         } else {
    //           if (localStorage.getItem("connectFusebill") !== '1') {
    //             this.context.router.history.push("/dashboard");
    //           } else {
    //             if (localStorage.getItem("plainNameDto") ==="Basic") {
    //               this.context.router.history.push("/dashboard");
    //             } else {
    //               this.setState({
    //                 successModalStatus: true,
    //                 iisLoader: false
    //               });
    //             }
    //           }
    //         }
    //       }
    //       // }
    //     }
    //   }
    // }

    if (plansDataAffiliate !== undefined) {
      if (params.affiliateKey !== undefined) {
        if (plansDataAffiliate.result !== undefined) {
          if (plansDataAffiliate.result.affiliateActive === 1) {
            if (plansDataAffiliate1 !== plansDataAffiliate) {
              Object.assign(plainDto, {
                records: plansDataAffiliate.result.affiliateSubscriptionDto.map,
              });

              // consumerPlanPriceId

              localStorage.setItem(
                "userTypeFooter",
                plansDataAffiliate.result.affiliateType !== "Consumer"
                  ? "Business-User"
                  : "Consumer"
              );
              // console.log('plansDataAffiliate', plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[1].planPriceDto[0].connectFusebill)
              this.setState({
                plansDataAffiliate1: plansDataAffiliate,
                AllPlansForMember1: plainDto,
                affiliateId: plansDataAffiliate.result.userId,
                connectFusebill:
                  plansDataAffiliate.result.affiliateSubscriptionDto.map
                    .Enterprise[1].planPriceDto[0].connectFusebill,
                isLoader: false,
                isLoaderDataSave: false,
                consumerPlanPriceId: plansDataAffiliate.result
                  .affiliateSubscriptionDto.map.Consumer[0]
                  ? plansDataAffiliate.result.affiliateSubscriptionDto.map
                      .Consumer[0].planPriceDto[0].planPriceId
                  : 23,
              });
              if (plansDataAffiliate.result.affiliateType === "Both") {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                  showTab: 2,
                  isConsumer: false,
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Business"
              ) {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                  showTab: 2,
                  indicatorBusiness: "active",
                  indicatorConsumer: "",
                  isConsumer: false,
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Consumer"
              ) {
                this.setState({
                  defaultIndex: 0,
                  showTab: 2,
                  indicatorBusiness: "",
                  indicatorConsumer: "active",
                  isConsumer: true,
                });
              }
              this.props.getAllPlans({
                pageNumber: 0,
                pageSize: 20,
                searchKeyword: "",
                planUserType: "Both",
                userId:
                  plansDataAffiliate.result.userId !== undefined
                    ? plansDataAffiliate.result.userId
                    : 0,
                affiliateKey:
                  this.props.match.params.affiliateKey !== undefined
                    ? this.props.match.params.affiliateKey
                    : "",
              });
            }
          } else {
            this.context.router.history.push("/signup-disabled");
          }
        }
      }
    }
    if (AllPlansForMember !== undefined) {
      if (params.affiliateKey === undefined) {
        if (AllPlansForMember.records !== undefined) {
          if (AllPlansForMember.records.Small !== undefined) {
            if (AllPlansForMember.records.Small.length > 0) {
              if (AllPlansForMember1 !== AllPlansForMember) {
                this.setState({
                  AllPlansForMember1: AllPlansForMember,
                });
              }
            }
            // console.log("Asdsasaa",AllPlansForMember.records.Small)
          }
        }
      }
    }
  }

  selectCompanySize = (enterpriseType) => {
    this.setState(
      {
        enterpriseType,
        selectedPlanAmount: "",
        durationData: "1 Month",
        planPriceId: "",
      },
      () => {
        this.isValidSignup1("enterpriseType");
        this.isValidCardDetail("");
      }
    );
  };

  selectAcceptCC = (acceptCC) => {
    this.setState(
      {
        acceptCC,
      },
      () => {
        this.isValidSignup1("acceptCC");
      }
    );
  };

  selectBankruptcyStatus = (bankruptcyStatus) => {
    this.setState(
      {
        bankruptcyStatus,
      },
      () => {
        this.isValidSignup1("bankruptcyStatus");
      }
    );
  };

  selectDissolvedStatus = (dissolvedStatus) => {
    this.setState(
      {
        dissolvedStatus,
      },
      () => {
        this.isValidSignup1("dissolvedStatus");
      }
    );
  };

  selectSeparateTaxId = (separateTaxId) => {
    this.setState(
      {
        separateTaxId,
        totalTaxId: separateTaxId === "no" ? 0 : 1,
      },
      () => {
        this.isValid("separateTaxId");
      }
    );
  };

  isValidConsumer(name) {
    const {
      errorsConsumerStatus,
      errors,
      isValidConsumer,
    } = this.validateInputConsumer(this.state, name);
    const { cFirstName, cLastName } = this.state;
    this.setState({
      errorsConsumerStatus: errorsConsumerStatus,
      errorsConsumer: errors,
      signatureDefaultValue: `${cFirstName} ${cLastName}`,
    });
    return isValidConsumer;
  }

  validateInputConsumer(data, label) {
    const { errorsConsumerStatus } = this.state;
    let errors = errorsConsumerStatus;
    const scrollViews = [];
    switch (label) {
      case "cFirstName":
        if (!data.cFirstName) {
          errors.cFirstName = "First name is required";
          errors.cFirstNameError = true;
          scrollViews.push(this.cFirstNameRef);
        } else if (data.cFirstName.length < 2) {
          errors.cFirstName = "Please enter at least 2 characters";
          errors.cFirstNameError = true;
          scrollViews.push(this.cFirstNameRef);
        } else {
          errors.cFirstName = "";
          errors.cFirstNameError = false;
        }
        break;

      case "cLastName":
        if (!data.cLastName) {
          errors.cLastName = "Last name is required";
          errors.cLastNameError = true;
          scrollViews.push(this.cLastNameRef);
        } else if (data.cLastName.length < 2) {
          errors.cLastName = "Please enter at least 2 characters";
          errors.cLastNameError = true;
          scrollViews.push(this.cLastNameRef);
        } else {
          errors.cLastName = "";
          errors.cLastNameError = false;
        }
        break;

      case "cPhone":
        if (!data.cPhone) {
          errors.cPhone = "Mobile number is required";
          errors.cPhoneError = true;
          scrollViews.push(this.cPhoneRef);
        } else if (
          data.cPhone.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
        ) {
          errors.cPhone = "Please provide a valid phone number";
          errors.cPhoneError = true;
          scrollViews.push(this.cPhoneRef);
        } else {
          errors.cPhone = "";
          errors.cPhoneError = false;
        }
        break;

      case "cEmployer":
        if (!data.cEmployer) {
          errors.cEmployer = "Employer name is required";
          errors.cEmployerError = true;
          scrollViews.push(this.cEmployerRef);
        } else if (data.cEmployer.length < 2) {
          errors.cEmployer = "Please enter at least 2 characters";
          errors.cEmployerError = true;
          scrollViews.push(this.cEmployerRef);
        } else {
          errors.cEmployer = "";
          errors.cEmployerError = false;
        }
        break;

      case "cSince":
        if (!data.cSince) {
          errors.cSince = "Since is required";
          errors.cSinceError = true;
          scrollViews.push(this.cSinceRef);
        } else {
          errors.cSince = "";
          errors.cSinceError = false;
        }

        break;

      case "cState":
        if (!data.cState) {
          errors.cState = "State is required";
          errors.cStateError = true;
          scrollViews.push(this.cStateRef);
        } else {
          errors.cState = "";
          errors.cStateError = false;
        }
        break;

      default:
        if (!data.cFirstName) {
          errors.cFirstName = "First name is required";
          errors.cFirstNameError = true;
          scrollViews.push(this.cFirstNameRef);
        } else if (data.cFirstName.length < 2) {
          errors.cFirstName = "Please enter at least 2 characters";
          errors.cFirstNameError = true;
          scrollViews.push(this.cFirstNameRef);
        } else {
          errors.cFirstName = "";
          errors.cFirstNameError = false;
        }

        if (!data.cLastName) {
          errors.cLastName = "Last name is required";
          errors.cLastNameError = true;
          scrollViews.push(this.cLastNameRef);
        } else if (data.cLastName.length < 2) {
          errors.cLastName = "Please enter at least 2 characters";
          errors.cLastNameError = true;
          scrollViews.push(this.cLastNameRef);
        } else {
          errors.cLastName = "";
          errors.cLastNameError = false;
        }

        if (!data.cPhone) {
          errors.cPhone = "Mobile number is required";
          errors.cPhoneError = true;
          scrollViews.push(this.cPhoneRef);
        } else if (
          data.cPhone.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
        ) {
          errors.cPhone = "Please provide a valid phone number";
          errors.cPhoneError = true;
          scrollViews.push(this.cPhoneRef);
        } else {
          errors.cPhone = "";
          errors.cPhoneError = false;
        }

        if (!data.cEmployer) {
          errors.cEmployer = "Employer name is required";
          errors.cEmployerError = true;
          scrollViews.push(this.cEmployerRef);
        } else if (data.cEmployer.length < 2) {
          errors.cEmployer = "Please enter at least 2 characters";
          errors.cEmployerError = true;
          scrollViews.push(this.cEmployerRef);
        } else {
          errors.cEmployer = "";
          errors.cEmployerError = false;
        }

        if (!data.cSince) {
          errors.cSince = "Since is required";
          errors.cSinceError = true;
          scrollViews.push(this.cSinceRef);
        } else {
          errors.cSince = "";
          errors.cSinceError = false;
        }

        if (!data.cState) {
          errors.cState = "State is required";
          errors.cStateError = true;
          scrollViews.push(this.cStateRef);
        } else {
          errors.cState = "";
          errors.cStateError = false;
        }
        break;
    }
    if (scrollViews.length > 0) {
      scrollToComponent(scrollViews[0], {
        offset: 200,
        align: "bottom",
        duration: 500,
        ease: "inExpo",
      });
    }

    return {
      errorsConsumerStatus: errors,
      errors:
        errors.cFirstNameError === false &&
        errors.cLastNameError === false &&
        errors.cPhoneError === false &&
        errors.cEmployerError === false &&
        errors.cSinceError === false &&
        errors.cStateError === false
          ? {}
          : errors,
      isValidConsumer: !(
        errors.cFirstNameError === false &&
        errors.cLastNameError === false &&
        errors.cPhoneError === false &&
        errors.cEmployerError === false &&
        errors.cSinceError === false &&
        errors.cStateError === false
      ),
    };
  }

  AfterLogin() {
    if (!this.state.isLoginCheck) {
      Auth.signIn(this.state.cEmail.toLowerCase(), this.state.cPassword)
        .then((user) => {
          const jwtToken = user.signInUserSession.accessToken.jwtToken;
          const postInfo = {
            email: this.state.cEmail.toLowerCase(),
            token: jwtToken,
            user,
          };
          this.props.requestApiData(postInfo);
          this.setState({ isLoginCheck: true });
          // setTimeout(() => { ; }, 1000);
        })
        .catch((error) => {
          this.setState({ isLoginCheck: false, isLoader: false });
          this.setState({ failedLoginMessages: error.message });
          // if (error.message === 'User is not confirmed.') {
          //   this.context.router.history.push('/verify-code');
          // }
        });
    }
  }

  async componentWillReceiveProps(nextProps) {
    let errors = {};
    errors = this.state.errors;
    const { BusinessUserData, RecieveConsumerUserData } = nextProps.data;
    const { isConsumer } = this.state;
    const isOk = nextProps.data.ConfirmUserEmailData;

    const isemailVerified = nextProps.data.emailVerifyData
      ? nextProps.data.emailVerifyData
      : {};

    if (isConsumer) {
      if (typeof RecieveConsumerUserData !== "undefined") {
        this.AfterLogin();
      }
    }
    if (Object.keys(isemailVerified).length > 0) {
      if (isemailVerified.collectMessage !== undefined) {
        if (
          isemailVerified.collectMessage.messageShort ===
          "User email already exist"
        ) {
          // errors.email = 'This user\'s email address has already been added to Collectively';
          errors.email = "Email address already exists";
          this.setState({
            isDisable: true,
            errors,
          });
        }
      }
    }
    if (typeof BusinessUserData !== "undefined") {
      if (!this.state.isLoginCheckS) {
        Auth.signIn(this.state.email.toLowerCase(), this.state.password)
          .then((user) => {
            const jwtToken = user.signInUserSession.accessToken.jwtToken;
            const postInfo = {
              email: this.state.email.toLowerCase(),
              token: jwtToken,
              user,
            };

            this.props.requestApiData(postInfo);
            this.setState({ isLoginCheckS: true });
            // this.context.router.history.push('/dashboard');
            // setTimeout(() => { this.props.history.push('/'); }, 1000);
          })
          .catch((error) => {
            this.setState({ failedLoginMessages: error.message });
            this.setState({ isLoginCheckS: false });
            if (error.message === "User is not confirmed.") {
              this.context.router.history.push("/verify-code");
            }
          });
      }
    }
    if (isOk.code === 400) {
      this.setState({
        errorForcodeverify: true,
      });
    }
  }

  verifyEmail = async () => {
    if (this.state.email !== "") {
      await this.props.checkEmailVerify({ email: this.state.email });
      // await this.isValidSignup();
    }
  };

  afterOpenModal = () => {};

  closeModalSuccess = () => {
    this.context.router.history.push("/dashboard");
  };

  _onSelectForPartner(e) {
    if (e.value == "facebook") {
      this.setState({
        hearAboutUs: "facebook",
        affiliateId: "",
      });
    } else {
      this.setState({
        hearAboutUs: "",
        affiliateId: e.value,
        defaultOptionAffilateState: e,
      });
    }
    console.log("latest", this.state.affiliateId, this.state.hearAboutUs);
    // const { affilateUserList } = this.props.data;

    // this.setState({
    //   affiliateId: e.value,
    //   // affiliateKeyId:
    //   // affilateUserList[
    //   //   affilateUserList.findIndex(
    //   //     data => data.userId === parseInt(e.target.value, 10)
    //   //   )
    //   // ] ? affilateUserList[
    //   //   affilateUserList.findIndex(
    //   //       data => data.userId === parseInt(e.target.value, 10)
    //   //     )
    //   //   ].stateName : ''
    // });
  }

  backChangeHandle = () => {
    this.setState({ backHandle: true });
  };
  toogleBackHandleChange = () => {
    this.setState({ backHandle: false });
  };
  render() {
    const {
      countryCode,
      email,
      errors,
      errorNumberPassword,
      file,
      planPriceId,
      errorUpperCasePassword,
      errorLimitPassword,
      errorSpecialPassword,
      errorLowerCasePassword,
      firstName,
      lastName,
      showTabPlan,
      showTabPlan1,
      showTabPlan2,
      showTabPlan3,
      showTabPlan4,
      showTabPlan5,
      workPhoneNumber,
      nonWorkPhoneNumber,
      companyName,
      streeAddress,
      streeAddress2,
      city,
      state,
      stateCard,
      zipCode,
      taxId,
      webSite,
      tabValue,
      tabValueConsumer,
      successModalStatus,
      failureModalStatus,
      durationCheckout,
      discountCheckout,
      // activeTab1Consumer,
      // activeTab2Consumer,
      // activeTab1,
      // activeTab2,
      // activeTab3,
      // activeTab4,
      IsSignatureForm,
      signatureDefaultValue,
      signatureFontFamily,
      errorsSignup,
      IsSignaUpForm1,
      companyTitle,
      planId,
      enterpriseType,
      errorsSignupPlan,
      acceptCC,
      bankruptcyStatus,
      dissolvedStatus,
      totalTaxId,
      separateTaxId,
      planName,
      connectFusebill,
      durationData,
      selectedPlanAmount,
      showTab,
      defaultIndex,
      activePlanForBussness,
      showplanDetail,
      cardNumber,
      cardFirstName,
      cardLastName,

      cardMonth,
      cardYear,
      cardCvv,
      cardAddress,
      cardAddress2,
      cardCity,
      cardZipCode,
      sameAddress,
      cNotification,
      cUpdateClaim,
      cTermsandCondition,
      isConsumer,
      cClaimUpdateText,
      cSince,
      cFirstName,
      cLastName,
      cPhone,
      cState,
      cEmployer,
      errorsConsumer,
      otherIndustryType,
      cardErrors,
      cOptionsSinceAdds,
      readDisclaimer,
      readUserAgreement,
      readPrivacyPolicy,
      readLetterOfAgency,
      password,
      industryTypeId,
      isLoader,
      isLoaderDataSave,
      startingYear,
      partnerType,
      indicatorBusiness,
      indicatorConsumer,
      affiliateId,
      hearAboutUs,
    } = this.state;
    console.log("hearAboutUs", this.state.hearAboutUs);
    const {
      AllStates,
      AllCountryData,
      IndustryData,
      plansDataAffiliate,
      AllPlansForMember,
      emailVerifyData,
      affilateUserList,
    } = this.props.data;

    const optionsSinceSince = [];
    optionsSinceSince.push({ value: "", label: "Year", name: "Year" });

    const currentDateSince = new Date().getFullYear();
    optionsSinceSince.push({
      value: 1989,
      label: "Prior to 1990",
      name: "Prior to 1990",
    });
    for (let i = 1990; i <= currentDateSince; i++) {
      optionsSinceSince.push({ value: i, label: i, name: i });
    }

    // selecting the first index to select
    const cSelectedSince = _.find(optionsSinceSince, { value: cSince });
    const cDefaultSince = cSelectedSince;

    const optionsSinceAdds = [];
    optionsSinceAdds.push({ value: "", label: "Select", name: "Select" });
    optionsSinceAdds.push({
      value: "Facebook",
      label: "Facebook Ad",
      name: "Facebook Ad",
    });
    // selecting the first index to select

    const cSelectedSinceAds = _.find(optionsSinceAdds, {
      value: cOptionsSinceAdds,
    });
    const cDefaultSinceAds = cSelectedSinceAds;

    const affilateUserListOption = [];
    let affilateUserListOptionOrdered = [];
    affilateUserListOption.unshift({
      value: "",
      name: "(None)",
      label: "(None)",
    });
    // affilateUserListOption.push({
    //   value: "",
    //   label: "Select",
    //   name: "Select",
    // });
    affilateUserListOption.push({
      value: "facebook",
      label: "Facebook Ad",
      name: "Facebook Ad",
    });
    if (affilateUserList) {
      if (affilateUserList.code !== 400) {
        affilateUserList &&
          affilateUserList.map((item) =>
            affilateUserListOption.push({
              value: item.userId,
              label: item.companyName,
              name: item.companyName,
            })
          );
      }
    }
    if (affilateUserListOption.length > 0) {
      affilateUserListOptionOrdered = affilateUserListOption.sort(function (
        a,
        b
      ) {
        var nameA = a.label.toUpperCase();
        var nameB = b.label.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      console.log(
        "affilateUserListOption",
        Array.isArray(affilateUserListOption),
        affilateUserListOptionOrdered
      );
    }

    const selectedAffilate = _.find(affilateUserListOption, {
      value: affiliateId ? affiliateId : this.state.hearAboutUs,
    });
    const defaultOptionAffilate = selectedAffilate;
    console.log("selectedAffilate", selectedAffilate);
    let affiliateHandleChange;
    if (this.state.backHandle && selectedAffilate !== "") {
      affiliateHandleChange = {
        value: "",
        label: "Select",
        name: "Select",
      };
    }

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    if (isLoaderDataSave) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    const options = [];
    options.push(
      <option key={0} value="">
        State
      </option>
    );
    AllStates.map((item) =>
      // return options.push({value: item.stateId, label: item.stateName, name: item.stateName})
      options.push(
        <option key={item.stateId} value={item.stateId}>
          {item.stateName}
        </option>
      )
    );

    const IndustryDataoptions = [];
    IndustryDataoptions.push({
      value: "",
      label: "Industry",
      name: "Industry",
    });
    if (IndustryData !== undefined) {
      if (IndustryData.code !== 400) {
        IndustryData.map((item) =>
          IndustryDataoptions.push({
            value: item.lookupTypeValueId,
            label: item.displayText,
            name: item.displayText,
          })
        );
      }
    }
    const optionsSince = [];
    optionsSince.push({
      value: "",
      label: "Year your business started",
      name: "Since",
    });
    optionsSince.push({
      value: "Prior to 1990",
      label: "Prior to 1990",
      name: "Since",
    });

    const currentDate = new Date().getFullYear();
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({ value: i.toString(), label: i, name: i });
    }
    // selecting the first index to select
    const cSelectedSince3 = _.find(optionsSince, { value: startingYear });
    const cDefaultSince3 = cSelectedSince3;

    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map((item) =>
        optionsCountry.push({
          value: item.countryCode,
          label: item.countryCode,
          name: item.countryCode,
        })
      );
    } else {
      optionsCountry.push({ value: "+1", label: "+1", name: "+1" });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    // selecting the first index to select
    const selectedIndustry = _.find(IndustryDataoptions, {
      value: industryTypeId,
    });
    const defaultOptionIndustry = selectedIndustry;
    // end

    let tabs;
    // console.log('ssssssssssssssssssss', partnerType, showTab)
    if (partnerType === "Consumer") {
      tabs = (
        <div style={{ display: showTab === 1 ? "block" : "none" }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6" disabled>
            <a className={indicatorBusiness}>I'm a business representative</a>
            {indicatorBusiness}
          </Tab>
        </div>
      );
    } else if (partnerType === "Business") {
      tabs = (
        <div style={{ display: showTab === 1 ? "block" : "none" }}>
          <Tab className="tab col s6" disabled>
            <a className={indicatorConsumer}>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>I'm a business representative</a>
            {indicatorBusiness}
          </Tab>
        </div>
      );
    } else if (showTab === 1) {
      tabs = (
        <div style={{ display: "block" }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>I'm a business representative</a>
            {indicatorBusiness}
          </Tab>
        </div>
      );
    } else if (localStorage.getItem("consumerTab") === 1) {
      tabs = (
        <div style={{ display: "block" }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>I'm a business representative</a>
            {indicatorBusiness}
          </Tab>
        </div>
      );
    } else {
      tabs = (
        <div style={{ display: "block" }}>
          <Tab className="tab col s6">
            <a className={indicatorConsumer}>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6">
            <a className={indicatorBusiness}>I'm a business representative</a>
            {indicatorBusiness}
          </Tab>
        </div>
      );
    }

    // end
    return (
      <div id="wrapper">
        <Modal
          isOpen={successModalStatus}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalSuccess}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
          // className="welcome-modal"
        >
          <div className="signup-signature welcome-modal center-align">
            <div className="tick-success">
              <i className="medium material-icons">check</i>
            </div>

            <h4>Payment Success</h4>
            <p>Thank you for your payment.</p>
            <p>Visit your dashboard to get started.</p>

            <Link className="btn-blue remove-trasformation" to="/dashboard">
              Go to my dashboard
            </Link>
          </div>
        </Modal>
        <Modal
          isOpen={failureModalStatus}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalSuccess}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
          // className="welcome-modal"
        >
          <div className="signup-signature welcome-modal center-align">
            <div className="tick-failure">
              <i className="medium material-icons">close</i>
            </div>

            <h4>Payment Failed</h4>
            <p>
              <Linkify>
                Please follow {""}
                <a href={this.state.zendeskLink}>this link</a>
                {""} to contact administrator.
              </Linkify>
            </p>
            {/* <p>Please follow <this link> to contact administrator.</p> */}

            <Link className="btn-blue remove-trasformation" to="/dashboard">
              Go to my dashboard
            </Link>
          </div>
        </Modal>
        {loader1}
        {isLoaderDataSave === false ? (
          <div className="container custom-container">
            <header className="section">
              <div className="logo center-align">
                <Link to="/">
                  <img className="responsive-img" src={logoImage} alt="" />
                </Link>
              </div>
            </header>
            <div className="signup-m2">
              <Link to="/" className="already-user">
                Already have an account?
              </Link>

              <Tabs
                selectedIndex={defaultIndex}
                className="react-tabs-form"
                onSelect={(defaultIndex1) =>
                  this.setState(
                    {
                      defaultIndex: defaultIndex1,
                      isConsumer: defaultIndex1 !== 1,
                    },
                    () => {
                      defaultIndex1 === 1
                        ? this.props.getPageDataFooter(7)
                        : this.props.getPageDataFooter(6);
                      this.props.clearDataEmail();
                      localStorage.clear();
                      this.props.clearSignupData();
                      localStorage.setItem(
                        "userTypeFooter",
                        defaultIndex1 === 1 ? "Business-User" : "Consumer"
                      );
                    }
                  )
                }
              >
                <TabList
                  id="tabs-swipe-demo"
                  style={{ display: showTab === 1 ? "none" : "none" }}
                  className="tabs"
                >
                  {tabs}
                </TabList>
                <TabPanel>
                  <Tabs
                    className="react-tabs-form-bussness"
                    selectedIndex={tabValueConsumer}
                    onSelect={(newValue) => {
                      this.setState({
                        tabValueConsumer: newValue,
                      });
                    }}
                  >
                    <div className="row consumer-tab-info ibmfont signup-new-tabs ">
                      <div className="col s12">
                        <TabList>
                          <Tab>1. Sign up</Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist"
                              )
                            }
                          >
                            2. BASIC INFO{" "}
                          </Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist" &&
                                isEmpty(errorsConsumer)
                              )
                            }
                          >
                            3. LEGAL{" "}
                          </Tab>
                        </TabList>
                      </div>
                      <div className="clear left col s12">
                        <TabPanel>
                          <EmailForm
                            isConsumer={isConsumer}
                            tabClick={this.handleClickUserType}
                            activeTabList={defaultIndex}
                            showTabBlock={
                              this.props.match.params.affiliateKey === undefined
                                ? "Both"
                                : plansDataAffiliate &&
                                  plansDataAffiliate.result &&
                                  plansDataAffiliate.result.affiliateType
                            }
                            //showTabBlock
                            cNotification={cNotification}
                            cUpdateClaim={cUpdateClaim}
                            cTermsandCondition={cTermsandCondition}
                            AckOnchangeCheckbox={this.AckOnchangeCheckbox}
                            emailVerifyData={emailVerifyData}
                            onChange={this.onChangePassword}
                            onChangeEmail={this.onChangeEmail}
                            finalSubmit={this.handleSubmitSignup}
                            errorsSignup={errorsSignup}
                            errorLowerCasePassword={errorLowerCasePassword}
                            errorSpecialPassword={errorSpecialPassword}
                            errorLimitPassword={errorLimitPassword}
                            errorUpperCasePassword={errorUpperCasePassword}
                            errorNumberPassword={errorNumberPassword}
                            email={email}
                            password={password}
                          />
                        </TabPanel>
                        <TabPanel>
                          <div
                            ref={(section) => {
                              this.signatureRef = section;
                            }}
                            className={
                              !IsSignaUpForm1
                                ? "section-content left-align create-signature"
                                : "hide"
                            }
                          >
                            <div
                              id="info-tab"
                              className="col s12 main-content signup-new-tabs-content ibmfont"
                            >
                              <div className="tab-inner step2-consumer">
                                <h4 className="center-align mt-mob-none">
                                  Basic Info
                                </h4>
                                <p className="center-align signup-title2 mb-none">
                                  To act on your behalf, we need the following
                                  information:
                                </p>
                                <div className="row">
                                  <form className="col s12">
                                    <div className="row">
                                      <div className="col s12 pb-20 pad-x-none">
                                        <h6 className="text-uppercase mt-mob-none">
                                          Name of Claimant
                                        </h6>
                                        <p className="signup-title2 pl-none">
                                          First and Last name must match the
                                          name on your bank account
                                          <Tooltip
                                            className="top-name"
                                            id="tooltip-icon"
                                            title="Collectively recovers funds on your behalf and places them into your claims wallet within the Collectively app.  In order to transfer funds from Collectively to your bank account, your first and last name entered during registration must match the name on your bank account."
                                          >
                                            <img
                                              className="question-mark"
                                              src={imgIcon}
                                              alt=""
                                            />
                                          </Tooltip>
                                        </p>
                                      </div>
                                      <div className=" input-field">
                                        <div className="row">
                                          <TextFieldGroupPartner
                                            field="cFirstName"
                                            label="First Name"
                                            placeholder="First"
                                            value={cFirstName}
                                            error={errorsConsumer.cFirstName}
                                            onChange={this.onChange1}
                                            divClassName="input-field col s12 col m6 pad-x-none claimaint-input-half-lt"
                                            req
                                          />

                                          <TextFieldGroupPartner
                                            field="cLastName"
                                            label="Last Name"
                                            placeholder="Last"
                                            value={cLastName}
                                            error={errorsConsumer.cLastName}
                                            onChange={this.onChange1}
                                            divClassName="input-field col s12 col m6 pad-x-none claimaint-input-half-rt"
                                            req
                                          />
                                        </div>
                                      </div>

                                      <div className="input-field col s12 pad-x-none consumer-country-phone">
                                        <div className="input-field col s4 input-half-lt font-medium">
                                          <label className="active claimaint-label">
                                            Country Code
                                          </label>
                                          <Dropdown
                                            name="cState"
                                            className="browser-default"
                                            options={optionsCountry}
                                            onChange={this._countrySelect}
                                            value={cDefaultOptionCountry}
                                            placeholder="Select an option*"
                                          />
                                        </div>
                                        <MaskInputNumber
                                          field="cPhone"
                                          label="Phone Number *"
                                          value={cPhone}
                                          error={errorsConsumer.cPhone}
                                          onChange={this.onChange1}
                                          divClassName="input-field col s8 input-half-rt pad-x-none"
                                        />
                                      </div>
                                      <div className="row">
                                        <div className="col s12 pb-10 pad-x-none i-agree">
                                          <label>
                                            <input
                                              type="checkbox"
                                              name="cClaimUpdateText"
                                              onChange={this.AckOnchangeText}
                                              value="1"
                                              checked={cClaimUpdateText === "1"}
                                            />
                                            <span className="font-medium-checkbox">
                                              I agree that you may text me
                                              update about my claims
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="input-field col s12 pad-x-none">
                                        <div className="input-field col s12 col m4 l2 pad-x-none p-x-none-mob mob-select-rel state-dd">
                                          <label className="active font-medium lt0">
                                            State*
                                          </label>
                                          <select
                                            className="pos-rel"
                                            name="state"
                                            value={cState}
                                            onChange={this.onSelectState}
                                            onClick={this.onSelectState}
                                          >
                                            {typeof options !== "undefined"
                                              ? options
                                              : ""}
                                          </select>
                                          {errorsConsumer &&
                                            errorsConsumer.cState && (
                                              <span className="help-block invalid pos-rel">
                                                {errorsConsumer.cState}
                                              </span>
                                            )}
                                        </div>
                                        <div className="input-field col s12 col m4 p-x-none-mob">
                                          <label className="xs-small active font-medium pl-10">
                                            Since*{" "}
                                          </label>
                                          <Tooltip
                                            id="tooltip-icon"
                                            title="Please tell us when did you move to your current state"
                                          >
                                            <img
                                              className="question-mark"
                                              src={imgIcon}
                                              alt=""
                                            />
                                          </Tooltip>

                                          <Dropdown
                                            name="cState"
                                            className="browser-default"
                                            options={optionsSinceSince}
                                            onChange={this._cSince}
                                            onFocus={this._cSince}
                                            value={cDefaultSince}
                                            placeholder="Select an option"
                                          />
                                          {errorsConsumer &&
                                            errorsConsumer.cSince && (
                                              <span className="help-block invalid ">
                                                {errorsConsumer.cSince}
                                              </span>
                                            )}
                                        </div>
                                      </div>

                                      <div className=" employer input-field ">
                                        <div className="row">
                                          <div className="input-field col s12 col m12 font-medium pad-x-none">
                                            <input
                                              onChange={this.onChange1}
                                              onClick={this.onChange1}
                                              value={cEmployer}
                                              name="cEmployer"
                                              id="Employer"
                                              placeholder="Who you work for"
                                              className="validate"
                                              // autoComplete="-"
                                            />
                                            <label
                                              className="active"
                                              htmlFor="Employer"
                                            >
                                              Employer *
                                            </label>
                                            <Tooltip
                                              id="tooltip-icon"
                                              title="If your current employer is a defendant in a specific class action, we wont share any settlement of that class action with you, although you may otherwise be eligible."
                                            >
                                              <img
                                                className="question-mark question-mark-left"
                                                src={imgIcon}
                                                alt=""
                                              />
                                            </Tooltip>
                                            {errorsConsumer &&
                                              errorsConsumer.cEmployer && (
                                                <span className="help-block invalid ">
                                                  {errorsConsumer.cEmployer}
                                                </span>
                                              )}
                                          </div>

                                          {this.props.match.params
                                            .affiliateKey === undefined ? (
                                            <div className="input-field col s12 col m12 mt-30 pad-x-none mb-none">
                                              <label className="xs-small active font-medium">
                                                How did you hear about us?
                                              </label>

                                              {/* <Dropdown
                                                className='browser-default mt-mob-10'
                                                options={affilateUserListOption}
                                                onChange={
                                                  this._onSelectForPartner
                                                }
                                                value={defaultOptionAffilate}
                                                placeholder='Select an option*'
                                              /> */}

                                              <Select
                                                className="browser-default  br-full mt-mob-10"
                                                // value={ affiliateHandleChange || defaultOptionAffilate}
                                                value={
                                                  this.state
                                                    .defaultOptionAffilateState
                                                }
                                                onChange={
                                                  this._onSelectForPartner
                                                }
                                                name="Select"
                                                onMenuOpen={
                                                  this.backChangeHandle
                                                }
                                                onMenuClose={
                                                  this.toogleBackHandleChange
                                                }
                                                options={
                                                  affilateUserListOptionOrdered
                                                }
                                                placeholder="Select an option*"
                                                clearValue={true}
                                                resetValue={true}
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}

                                          {/* <TextFieldGroupPartner
                                          field="cEmployer"
                                          label="Employer"
                                          placeholder="Who you work for"
                                          value={cEmployer}
                                          error={errors.cEmployer}
                                          onChange={this.onChange1}
                                          divClassName="input-field col s12 col m12 pb-10"
                                          image={imgIcon}
                                          req
                                        /> */}

                                          {/* <div className='input-field col s12 col m12 mt-30 pad-x-none mb-none'>
                                            <label className='xs-small active font-medium'>
                                              How did you hear about us?
                                            </label>
                                            <Dropdown
                                              name='cState'
                                              className='browser-default'
                                              options={optionsSinceAdds}
                                              onChange={this._cSinceAdds}
                                              value={cDefaultSinceAds}
                                              placeholder='Select an option'
                                            />
                                          </div> */}
                                        </div>
                                      </div>

                                      <div className="col s12 center-align input-field claimant-btns checkout-btns pad-x-none">
                                        {this.state.backHandle ? (
                                          ""
                                        ) : (
                                          <div>
                                            <button
                                              className=" waves-effect waves-light white-btn"
                                              type="submit"
                                              onClick={() => {
                                                this.setState(
                                                  {
                                                    tabValueConsumer: 0,
                                                  },
                                                  () => {
                                                    window.scrollTo(0, 0);
                                                  }
                                                );
                                              }}
                                              name="action"
                                            >
                                              Back
                                            </button>
                                            <button
                                              disabled={
                                                !isEmpty(errorsConsumer)
                                              }
                                              className={
                                                !isEmpty(errorsConsumer)
                                                  ? " waves-effect waves-light ltgrey-btn"
                                                  : " waves-effect waves-light pink-btn"
                                              }
                                              type="submit"
                                              onClick={
                                                this.handleSubmitConsumer
                                              }
                                              name="action"
                                            >
                                              Next
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <TermAndCondition
                            termsAndConditionData={this.handleSaveData}
                            termsAndConditionDataNextPage={
                              this.handleSaveDataNext
                            }
                            termsAndConditionBack={this.backClick}
                            readDisclaimer={readDisclaimer}
                            readUserAgreement={readUserAgreement}
                            readPrivacyPolicy={readPrivacyPolicy}
                            readLetterOfAgency={readLetterOfAgency}
                            pageType="consumer"
                            backButton
                            signupData={this.state}
                            defaultValue={signatureDefaultValue}
                            fontFamily={signatureFontFamily}
                            // finalSubmitData={this.finalSubmit}
                            fileImage={this.fileImage}
                            moveTop={this.topScreen}
                            fileData={file}
                            hide
                            isConsumer
                          />
                        </TabPanel>
                      </div>
                    </div>
                  </Tabs>
                </TabPanel>

                <TabPanel className="active ">
                  <Tabs
                    className="react-tabs-form-bussness"
                    selectedIndex={tabValue}
                    onSelect={(newValue) => {
                      this.setState((prevState) => ({
                        tabValue: newValue,
                        IsSignaUpForm1: false,
                        IsSignatureForm: false,
                        recaptchaToken: "",
                        cardErrors: {
                          ...prevState.cardErrors,
                          recaptchaTokenError: true,
                        },
                      }));
                    }}
                    // this.setState( prevState => ({
                    //   cardErrors: {
                    //     ...prevState.cardErrors,
                    //     recaptchaTokenError: true
                    //   }}
                  >
                    <div className="row ibmfont signup-new-tabs">
                      {/* <div className="col s12 list-count-cursor"> */}
                      <div className="col s12">
                        <TabList aria-label="simple tabs example">
                          <Tab>
                            <span className="list-count"> 1. </span> Sign up
                          </Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist"
                              )
                            }
                          >
                            {" "}
                            <span className=""> 2.</span> Claimant Info{" "}
                          </Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist" &&
                                isEmpty(errors) &&
                                isEmpty(errorsSignupPlan)
                              )
                            }
                          >
                            {" "}
                            <span className=""> 3.</span> Pick A Plan{" "}
                          </Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist" &&
                                isEmpty(errors) &&
                                isEmpty(errorsSignupPlan) &&
                                planId !== ""
                              )
                            }
                          >
                            {" "}
                            <span className=""> 4.</span> Legal
                          </Tab>
                          <Tab
                            disabled={
                              !(
                                isEmpty(errorsSignup) &&
                                emailVerifyData &&
                                emailVerifyData.collectMessage &&
                                emailVerifyData.collectMessage.messageShort !==
                                  "User email already exist" &&
                                isEmpty(errors) &&
                                isEmpty(errorsSignupPlan) &&
                                planId !== "" &&
                                readUserAgreement === "1" &&
                                readLetterOfAgency === "1" &&
                                readPrivacyPolicy === "1" &&
                                readDisclaimer === "1" &&
                                file !== "" &&
                                planName !== "" &&
                                selectedPlanAmount !== ""
                              )
                            }
                            className={
                              planName === "Basic" || connectFusebill === 0
                                ? //? "hide-tab-info list-count-cursor"
                                  "hide-tab-info"
                                : !(
                                    isEmpty(errorsSignup) &&
                                    emailVerifyData &&
                                    emailVerifyData.collectMessage &&
                                    emailVerifyData.collectMessage
                                      .messageShort !==
                                      "User email already exist" &&
                                    isEmpty(errors) &&
                                    isEmpty(errorsSignupPlan) &&
                                    planId !== "" &&
                                    readUserAgreement === "1" &&
                                    readLetterOfAgency === "1" &&
                                    readPrivacyPolicy === "1" &&
                                    readDisclaimer === "1" &&
                                    file !== "" &&
                                    planName !== "" &&
                                    selectedPlanAmount !== ""
                                  )
                                ? ""
                                : "" //"list-count-cursor"
                            }
                          >
                            <span className=""> 5.</span> Checkout
                          </Tab>
                        </TabList>
                      </div>
                      <div className="clear left col s12">
                        <TabPanel>
                          <EmailForm
                            emailVerifyData={emailVerifyData}
                            showTabBlock={
                              this.props.match.params.affiliateKey === undefined
                                ? "Both"
                                : plansDataAffiliate &&
                                  plansDataAffiliate.result &&
                                  plansDataAffiliate.result.affiliateType
                            }
                            tabClick={this.handleClickUserType}
                            activeTabList={defaultIndex}
                            onChange={this.onChangePassword}
                            onChangeEmail={this.onChangeEmail}
                            finalSubmit={this.handleSubmitSignup}
                            errorsSignup={errorsSignup}
                            errorLowerCasePassword={errorLowerCasePassword}
                            errorSpecialPassword={errorSpecialPassword}
                            errorLimitPassword={errorLimitPassword}
                            errorUpperCasePassword={errorUpperCasePassword}
                            errorNumberPassword={errorNumberPassword}
                            email={email}
                            password={password}
                          />
                        </TabPanel>
                        <TabPanel>
                          <div
                            ref={(section) => {
                              this.signatureRef = section;
                            }}
                            className={
                              !IsSignaUpForm1
                                ? "section-content left-align create-signature"
                                : "hide"
                            }
                          >
                            <div
                              id="info-tab"
                              className="col s12 main-content signup-new-tabs-content ibmfont"
                            >
                              <div className="tab-inner step2">
                                <h4 className="center-align ">
                                  Claimant Information
                                </h4>
                                <p className="center-align signup-title2 mb-8 font-medium">
                                  To act on your behalf, we need the following
                                  information:
                                </p>
                                <div className="row">
                                  <form className="col s12">
                                    <div className="row">
                                      <div className="pb-10">
                                        <h6 className=" text-uppercase claimant-subhdr">
                                          Name of Authorized Individual
                                        </h6>
                                        <p className="signup-title2">
                                          Contact information for the individual
                                          signing up on behalf of the company
                                        </p>
                                      </div>
                                      <div className=" input-field">
                                        <div className="row">
                                          <TextFieldGroupPartner
                                            field="firstName"
                                            label="First Name"
                                            placeholder="First"
                                            value={firstName}
                                            error={errors.firstName}
                                            onChange={this.onChange}
                                            divClassName="input-field col s12 col m6 claimaint-input-half-lt mb-mob-25"
                                            req
                                          />

                                          <TextFieldGroupPartner
                                            field="lastName"
                                            label="Last Name"
                                            placeholder="Last"
                                            value={lastName}
                                            error={errors.lastName}
                                            onChange={this.onChange}
                                            divClassName="input-field col s12 col m6 claimaint-input-half-rt"
                                            req
                                          />
                                        </div>
                                      </div>

                                      <TextFieldGroupPartner
                                        field="companyTitle"
                                        label="Title"
                                        value={companyTitle}
                                        placeholder="Position in company"
                                        error={errors.companyTitle}
                                        onChange={this.onChange}
                                        divClassName="input-field col s12"
                                        req
                                      />

                                      <div className="input-field col s12 pad-x-none">
                                        <div className="input-field col s4 pl-none font-medium">
                                          <label className="active claimaint-label">
                                            Country Code
                                          </label>
                                          <Dropdown
                                            name="cState"
                                            className="browser-default"
                                            options={optionsCountry}
                                            onChange={this._countrySelect}
                                            value={cDefaultOptionCountry}
                                            placeholder="Select an option*"
                                          />
                                        </div>
                                        <MaskInputNumber
                                          field="workPhoneNumber"
                                          label="Work Phone Number *"
                                          value={workPhoneNumber}
                                          error={errors.workPhoneNumber}
                                          onChange={this.onChange}
                                          divClassName="input-field col s8 pr-none"
                                        />
                                      </div>
                                      <div className="row">
                                        <div className="col s12 pad-x-none">
                                          <div className="input-field col s4 input-half-lt font-medium">
                                            <label className="active claimaint-label">
                                              Country Code
                                            </label>
                                            <Dropdown
                                              name="cState"
                                              className="browser-default"
                                              options={optionsCountry}
                                              onChange={this._countrySelect}
                                              value={cDefaultOptionCountry}
                                              placeholder="Select an option*"
                                            />
                                          </div>

                                          <MaskInputNumber
                                            field="nonWorkPhoneNumber"
                                            label="Mobile Phone Number *"
                                            value={nonWorkPhoneNumber}
                                            error={errors.nonWorkPhoneNumber}
                                            onChange={this.onChange}
                                            divClassName="input-field col s8 input-half-rt"
                                          />
                                        </div>
                                      </div>
                                      <div className="col s12 pad-x-none">
                                        <h6 className=" pb-10 text-uppercase signup-title-inner claimant-subhdr">
                                          Company Information
                                        </h6>
                                      </div>

                                      <TextFieldGroupPartner
                                        field="companyName"
                                        label="Company Name"
                                        value={companyName}
                                        error={errors.companyName}
                                        placeholder="Full legal and DBA if applicable"
                                        onChange={this.onChange}
                                        divClassName="input-field col s12 input-half-rt pb-10 mb-24"
                                        req
                                      />

                                      <TextFieldGroupPartner
                                        field="streeAddress"
                                        label="Address 1"
                                        placeholder="Street Address"
                                        value={streeAddress}
                                        error={errors.streeAddress}
                                        onChange={this.onChange}
                                        divClassName="input-field col s12 input-half-rt pb-10 mb-24"
                                        req
                                      />

                                      <TextFieldGroupPartner
                                        field="streeAddress2"
                                        label="Address 2 (optional)"
                                        placeholder="Suite, Unit #, etc."
                                        value={streeAddress2}
                                        // error={errors.streeAddress}
                                        onChange={this.onChange}
                                        divClassName="input-field col s12 input-half-rt pb-10 mb-24"
                                      />

                                      <div className="row">
                                        <TextFieldGroupPartner
                                          field="city"
                                          label="City"
                                          value={city}
                                          error={errors.city}
                                          onChange={this.onChange}
                                          divClassName="input-field col s4 pb-10 claimaint-input-quater-lt mb-24"
                                          req
                                        />
                                        <div className="input-field col s12 col m4 font-medium claimaint-input-quater-mid state-select-mob">
                                          <label className="active">
                                            State*
                                          </label>
                                          <select
                                            name="state"
                                            value={state}
                                            onChange={this._onSelect}
                                            onClick={this._onSelect}
                                          >
                                            {typeof options !== "undefined"
                                              ? options
                                              : ""}
                                          </select>

                                          {/* <div className="col s4 input-half-lt custom-select">
                                        <label className="active font-scale">State*</label>
                                        <select name="state" onChange={this._onSelect}>
                                          {(typeof options !== 'undefined') ? (options) : ''}
                                        </select> */}

                                          <span
                                            className={
                                              errors.stateError
                                                ? "show invalid dropdown-error-msg"
                                                : "hide"
                                            }
                                          >
                                            {errors.state}
                                          </span>
                                        </div>

                                        <CardInputMaskinking
                                          divClassName="input-field col s4 input-half-rt font-medium claimaint-input-quater-rt"
                                          field="zipCode"
                                          label="Zip Code"
                                          // placeholder="Zip Code"
                                          value={zipCode}
                                          error={errors.zipCode}
                                          onChange={this.onChange}
                                          mask="99999"
                                        />
                                      </div>

                                      <MaskInputEinNumber
                                        field="taxId"
                                        label="Tax ID (EIN)*"
                                        value={taxId}
                                        error={errors.taxId}
                                        onChange={this.onChange}
                                        divClassName="input-field col s12 pad-x-none mt-mob-20"
                                      />

                                      <div className=" col s12 font-medium pad-x-none do-you-have">
                                        <p className="mt-mob-none">
                                          Do you have additional business
                                          entities/locations with separate EINs?
                                          *
                                        </p>
                                        <a
                                          className={
                                            separateTaxId === "yes"
                                              ? "blue-bdr-btn activeButionSignup"
                                              : "blue-bdr-btn"
                                          }
                                          onClick={() =>
                                            this.selectSeparateTaxId("yes")
                                          }
                                        >
                                          Yes
                                        </a>
                                        <a
                                          className={
                                            separateTaxId === "no"
                                              ? "blue-bdr-btn activeButionSignup"
                                              : "blue-bdr-btn"
                                          }
                                          onClick={() =>
                                            this.selectSeparateTaxId("no")
                                          }
                                        >
                                          No
                                        </a>
                                      </div>
                                      <div
                                        className={
                                          separateTaxId === "yes"
                                            ? "input-field col s12 pad-x-none mb-none"
                                            : "hide mb-none"
                                        }
                                      >
                                        <div className=" how-many-lt font-medium">
                                          <input
                                            id="Email"
                                            name="totalTaxId"
                                            placeholder="How many ?"
                                            type="number"
                                            value={totalTaxId}
                                            onChange={this.onChangeTaxId}
                                            className="validate"
                                          />
                                          <label
                                            className="active"
                                            htmlFor="Email"
                                          >
                                            How many ?*
                                          </label>

                                          {errors && errors.totalTaxIdError && (
                                            <span className="help-block invalid ">
                                              {errors.totalTaxId}
                                            </span>
                                          )}
                                        </div>

                                        <div className="input-field how-many-rt multiple-note mb-none">
                                          <b>Note:</b> Multiple business
                                          entities/EINs can be uploaded on your
                                          My Profile tab in the Collectively
                                          dashboard, once your registration is
                                          complete.
                                          <label htmlFor="Email">&nbsp;</label>
                                        </div>
                                      </div>

                                      <div className="col s12 center-align pad-x-none input-field claimant-btns checkout-btns">
                                        <button
                                          className=" waves-effect waves-light white-btn"
                                          type="submit"
                                          onClick={() => {
                                            this.setState(
                                              { tabValue: 0 },
                                              () => {
                                                window.scrollTo(0, 0);
                                              }
                                            );
                                          }}
                                          name="action"
                                        >
                                          Back
                                        </button>
                                        <button
                                          disabled={!isEmpty(errors)}
                                          className={
                                            !isEmpty(errors)
                                              ? " waves-effect waves-light ltgrey-btn"
                                              : " waves-effect waves-light pink-btn"
                                          }
                                          type="submit"
                                          onClick={this.handleSubmit}
                                          name="action"
                                        >
                                          Next
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            ref={(section) => {
                              this.signatureRef = section;
                            }}
                            className={
                              IsSignaUpForm1
                                ? "section-content left-align create-signature"
                                : "hide"
                            }
                          >
                            <div
                              id="info-tab"
                              className="col s12 main-content signup-new-tabs-content ibmfont"
                            >
                              <div className="tab-inner step3">
                                <h4 className="center-align">
                                  Claimant Information
                                </h4>
                                <p className="center-align signup-title2 font-medium mb-8">
                                  To help provide you with the best solutions,
                                  please tell us a little more about your
                                  company
                                </p>
                                <div className="">
                                  <div className="row">
                                    <div className="col s12 pad-x-none">
                                      <h6 className="signup-title2 pb-10 signup-title3 mt-mob-none pl-mob-none mb-15">
                                        ADDITIONAL COMPANY INFO
                                      </h6>
                                    </div>
                                    <div className="row input-field">
                                      <div className="input-field col s12 l7 pl-none pr-mob-none mb-24">
                                        <label className="active font-medium">
                                          Industry*
                                        </label>
                                        <Dropdown
                                          className="browser-default"
                                          options={IndustryDataoptions}
                                          onChange={this._onSelectForYears}
                                          onFocus={this._onSelectForYears}
                                          value={defaultOptionIndustry}
                                          placeholder="Select an option*"
                                        />
                                        <span
                                          className={
                                            errorsSignupPlan.industryTypeId
                                              ? "show invalid"
                                              : "hide"
                                          }
                                        >
                                          {errorsSignupPlan.industryTypeId}
                                        </span>
                                      </div>

                                      <div className="input-field col s12 l5 input-half-rt pl-mob-none">
                                        <label className="active pl-10 font-medium year-business-mob pl-mob-none">
                                          Year Business Started *
                                        </label>
                                        <Dropdown
                                          name="cState"
                                          className="browser-default mt-mob-10 {
                                          margin-top: 10px;
                                        }"
                                          options={optionsSince}
                                          onChange={this._cSince1}
                                          onFocus={this._cSince1}
                                          value={cDefaultSince3}
                                          placeholder="Starting Year*"
                                        />
                                        <span
                                          className={
                                            errorsSignupPlan.startingYearError
                                              ? "show invalid"
                                              : "hide"
                                          }
                                        >
                                          {errorsSignupPlan.startingYear}
                                        </span>
                                      </div>
                                    </div>
                                    {industryTypeId === 119 ? (
                                      <div className="row">
                                        <TextFieldGroupPartner
                                          field="otherIndustryType"
                                          label="Other Industry*"
                                          value={otherIndustryType}
                                          error={
                                            errorsSignupPlan.otherIndustryType
                                          }
                                          // onChange={this.onChange}
                                          onChange={(event) => {
                                            this.setState(
                                              {
                                                otherIndustryType: event.target.value.trimLeft(),
                                              },
                                              () => {
                                                this.isValidSignup1(
                                                  "otherIndustryType"
                                                );
                                              }
                                            );
                                          }}
                                          onClick={() => {
                                            this.isValidSignup1(
                                              "otherIndustryType"
                                            );
                                          }}
                                          placeholder=" "
                                          divClassName="input-field col s12"
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <TextFieldGroupPartner
                                      field="webSite"
                                      label="Website (optional)"
                                      value={webSite}
                                      error={errorsSignupPlan.webSite}
                                      onChange={(event) => {
                                        this.setState(
                                          {
                                            webSite: event.target.value,
                                          },
                                          () => {
                                            this.isValidSignup1("webSite");
                                          }
                                        );
                                      }}
                                      placeholder="  "
                                      divClassName="input-field col s12 input-half-rt mt-30 mb-30"
                                    />

                                    {this.props.match.params.affiliateKey ===
                                    undefined ? (
                                      <div className="input-field col s12 col m12 mt-30 pad-x-none mb-none">
                                        {" "}
                                        <label className="xs-small active font-medium">
                                          How did you hear about us?
                                        </label>{" "}
                                      </div>
                                    ) : (
                                      ""
                                    )}

                                    {this.props.match.params.affiliateKey ===
                                    undefined ? (
                                      <div className="input-field col s12 col m12 pad-x-none mt-none mb-24">
                                        {/* <Dropdown
                                          className='browser-default mt-mob-10'
                                          options={affilateUserListOption}
                                          onChange={this._onSelectForPartner}
                                          value={defaultOptionAffilate}
                                          placeholder='Select an option*'
                                        /> */}
                                        <Select
                                          className="browser-default br-full mt-mob-10"
                                          value={
                                            this.state
                                              .defaultOptionAffilateState
                                          }
                                          onChange={this._onSelectForPartner}
                                          name="Select"
                                          onMenuOpen={this.backChangeHandle}
                                          onMenuClose={
                                            this.toogleBackHandleChange
                                          }
                                          options={
                                            affilateUserListOptionOrdered
                                          }
                                          placeholder="Select an option*"
                                          clearValue={true}
                                          resetValue={true}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}

                                    <div className=" col s12 pad-x-none">
                                      <p className="font-medium mt-none mb-8">
                                        What size is your Company? *
                                      </p>
                                    </div>

                                    <div className="col s12 small-medium-business pad-x-none mb-24">
                                      <a
                                        className={
                                          enterpriseType === "S"
                                            ? "blue-bdr-btn col s12 m7 l7 center-align activeButionSignup smb-btn"
                                            : "blue-bdr-btn col s12 m7 l7 center-align smb-btn"
                                        }
                                        onClick={() =>
                                          this.selectCompanySize("S")
                                        }
                                      >
                                        Small-to-Medium Business (SMB)
                                      </a>
                                      <Tooltip
                                        id="tooltip-icon"
                                        title="Large Enterprise is a company that has over $100 million in annual revenue and/or more than 1000 employees"
                                      >
                                        <a
                                          className={
                                            enterpriseType === "E"
                                              ? "blue-bdr-btn col s7 m4 l4 center-align activeButionSignup large-enterprice-mob"
                                              : "blue-bdr-btn col s7 m4 l4 center-align large-enterprice-mob"
                                          }
                                          onClick={() =>
                                            this.selectCompanySize("E")
                                          }
                                        >
                                          Large Enterprise
                                        </a>
                                      </Tooltip>
                                      {/* <span
                                      className={errorsSignupPlan.enterpriseTypeError ? 'show invalid mt-10' : 'hide'}
                                    >
                                      {errorsSignupPlan.enterpriseType}

                                    </span> */}
                                    </div>

                                    <div className="input-field col s12 pad-x-none mt-none mb-30">
                                      <p className="font-medium mt-mob-none mt-none">
                                        Does your company accept credit cards? *
                                      </p>
                                      <a
                                        className={
                                          acceptCC === "Y"
                                            ? "blue-bdr-btn activeButionSignup mr-28"
                                            : "blue-bdr-btn mr-28"
                                        }
                                        onClick={() => this.selectAcceptCC("Y")}
                                      >
                                        Yes
                                      </a>
                                      <a
                                        className={
                                          acceptCC === "N"
                                            ? "blue-bdr-btn activeButionSignup"
                                            : "blue-bdr-btn"
                                        }
                                        onClick={() => this.selectAcceptCC("N")}
                                      >
                                        No
                                      </a>
                                      {/* <span
                                      className={errorsSignupPlan.acceptCCError ? 'show invalid mt-10' : 'hide'}
                                    >
                                      {errorsSignupPlan.acceptCC}

                                    </span> */}
                                    </div>

                                    <div className="input-field col s12 pad-x-none mt-none">
                                      <p className="font-medium mt-mob-none mt-none">
                                        Did the company file for bankruptcy
                                        since 1/1/04?*
                                      </p>
                                      <a
                                        className={
                                          bankruptcyStatus === "Y"
                                            ? "blue-bdr-btn activeButionSignup mr-28"
                                            : "blue-bdr-btn mr-28"
                                        }
                                        onClick={() =>
                                          this.selectBankruptcyStatus("Y")
                                        }
                                      >
                                        Yes
                                      </a>
                                      <a
                                        className={
                                          bankruptcyStatus === "N"
                                            ? "blue-bdr-btn activeButionSignup"
                                            : "blue-bdr-btn"
                                        }
                                        onClick={() =>
                                          this.selectBankruptcyStatus("N")
                                        }
                                      >
                                        No
                                      </a>
                                      {/* <span
                                      className={errorsSignupPlan.bankruptcyStatusError ? 'show invalid mt-10' : 'hide'}
                                    >
                                      {errorsSignupPlan.bankruptcyStatus}

                                    </span> */}
                                    </div>

                                    <div className="input-field col s12 pad-x-none mb-none">
                                      <p className="font-medium mt-mob-none mt-none">
                                        Did the company dissolve since 1/1/04?*
                                      </p>
                                      <a
                                        className={
                                          dissolvedStatus === "Y"
                                            ? "blue-bdr-btn activeButionSignup mr-28"
                                            : "blue-bdr-btn mr-28"
                                        }
                                        onClick={() =>
                                          this.selectDissolvedStatus("Y")
                                        }
                                      >
                                        Yes
                                      </a>
                                      <a
                                        className={
                                          dissolvedStatus === "N"
                                            ? "blue-bdr-btn activeButionSignup"
                                            : "blue-bdr-btn"
                                        }
                                        onClick={() =>
                                          this.selectDissolvedStatus("N")
                                        }
                                      >
                                        No
                                      </a>
                                      {/* <span
                                      className={errorsSignupPlan.dissolvedStatusError ? 'show invalid mt-10' : 'hide'}
                                    >
                                      {errorsSignupPlan.dissolvedStatus}

                                    </span> */}
                                    </div>
                                    <div className="col s12 center-align input-field claimant-btns checkout-btns pad-x-none">
                                      <button
                                        className=" waves-effect waves-light white-btn"
                                        type="submit"
                                        onClick={() => {
                                          this.setState(
                                            {
                                              IsSignaUpForm1: false,
                                            },
                                            () => {
                                              window.scrollTo(0, 0);
                                            }
                                          );
                                        }}
                                        name="action"
                                      >
                                        Back
                                      </button>
                                      <button
                                        disabled={!isEmpty(errorsSignupPlan)}
                                        className={
                                          !isEmpty(errorsSignupPlan)
                                            ? " waves-effect waves-light ltgrey-btn"
                                            : " waves-effect waves-light pink-btn"
                                        }
                                        type="submit"
                                        onClick={this.handleSubmitPlanPage}
                                        name="action"
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <div className="d-flex  plan-outer pick-a-plan">
                            <div
                              id="additional-tab"
                              className=" plans-outer plans-new-signup ibmfont"
                            >
                              <div className="pick-plan-outer">
                                <p className="center-align choose-plan-type">
                                  Choose the type of plan you want:
                                </p>
                                <div className="pick-plan-btn-outer">
                                  <button
                                    type="submit"
                                    name="action"
                                    onClick={() => {
                                      this.setState({
                                        activePlanForBussness: "Premium",
                                      });
                                    }}
                                    className={
                                      activePlanForBussness === "Premium"
                                        ? " waves-effect waves-light btn-small ltblue-btn text-700"
                                        : "waves-effect waves-light btn-small white-btn text-700"
                                    }
                                  >
                                    Claims filed automatically
                                  </button>
                                  <span className="or">or</span>
                                  <button
                                    onClick={() => {
                                      this.setState({
                                        activePlanForBussness: "flex",
                                      });
                                    }}
                                    className={
                                      activePlanForBussness === "flex"
                                        ? " waves-effect waves-light btn-small ltblue-btn text-700"
                                        : "waves-effect waves-light btn-small white-btn text-700"
                                    }
                                    type="submit"
                                    name="action"
                                  >
                                    I want to be more hands-on
                                  </button>
                                </div>
                                <h6 className="center-align best-plan-hdr">
                                  Select the best plan for you:
                                </h6>
                              </div>

                              {enterpriseType === "S" ? (
                                <div className=" plan-flex">
                                  <div
                                    className={
                                      activePlanForBussness === "Premium"
                                        ? "step-3"
                                        : "step-3 disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one">
                                      <h5 className="text-uppercase text-700 signup-title">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[0] &&
                                            AllPlansForMember.records.Small[0]
                                              .planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planName
                                          : ""}
                                      </h5>
                                      <h5 className="signup-title2">
                                        No Upfront Cost
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[0] &&
                                              AllPlansForMember.records.Small[0]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Small[0].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[0].planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[0].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="font-medium forcompany-web forcompany-mob">
                                        For companies that want to try out
                                        Collectively
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[0]
                                                  ? AllPlansForMember.records
                                                      .Small[0].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[0]
                                                  ? AllPlansForMember.records
                                                      .Small[0].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[0]
                                                  ? AllPlansForMember.records
                                                      .Small[0]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[0].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[0].planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[0]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[0] &&
                                              AllPlansForMember.records.Small[0]
                                                .planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[0] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[0].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>
                                      <div
                                        className={
                                          showTabPlan5
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            VISA/Mastercard claim included
                                          </li>
                                          <li>
                                            File upto 10 claims per entity{" "}
                                            <sup>2</sup>
                                          </li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                          <li>Upgrade at anytime</li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan5: !showTabPlan5,
                                          });
                                        }}
                                      >
                                        {showTabPlan5
                                          ? "Show less"
                                          : "Show more"}

                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan5
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      activePlanForBussness === "Premium"
                                        ? "step-3"
                                        : "col m4  step-3 disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one premium-plan">
                                      <span className="best-value text-700 text-uppercase">
                                        Best value
                                      </span>
                                      <h5 className="text-uppercase text-700 signup-title text-pink">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[1] &&
                                            AllPlansForMember.records.Small[1]
                                              .planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[1]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[1].planName
                                          : ""}
                                      </h5>
                                      <h5 className="signup-title2">
                                        $
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[1] &&
                                            AllPlansForMember.records.Small[1]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Small[1].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[1].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[1].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )}
                                        /month <sup>1</sup>
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[1] &&
                                              AllPlansForMember.records.Small[1]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Small[1].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[0].planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[1].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}{" "}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="font-medium forcompany-web forcompany-mob">
                                        For companies that want claims filed
                                        automatically
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[1]
                                                  ? AllPlansForMember.records
                                                      .Small[1].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[1]
                                                  ? AllPlansForMember.records
                                                      .Small[1].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[1]
                                                  ? AllPlansForMember.records
                                                      .Small[1]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[1]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[1].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[1]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[1].planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[1]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[1] &&
                                              AllPlansForMember.records.Small[1]
                                                .planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[1] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[1].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>
                                      <div
                                        className={
                                          showTabPlan4
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            Claims filed automatically
                                            <sup>2</sup>
                                          </li>
                                          <li>Unlimited claim filings</li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                          <li>
                                            {" "}
                                            Each additional EIN is +$1.00/month
                                            <br /> (capped at $250/month)
                                          </li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan4: !showTabPlan4,
                                          });
                                        }}
                                      >
                                        {showTabPlan4
                                          ? "Show less"
                                          : "Show more"}

                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan4
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      activePlanForBussness === "flex"
                                        ? "step-3"
                                        : "step-3 disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one premium-plan">
                                      <h5 className="text-uppercase text-700 signup-title">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[2] &&
                                            AllPlansForMember.records.Small[2]
                                              .planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[2]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[2].planName
                                          : ""}
                                      </h5>
                                      <h5 className="signup-title2 text-pink">
                                        $
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[2] &&
                                            AllPlansForMember.records.Small[2]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Small[2].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[2].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )}
                                        /month <sup>1</sup>
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[2] &&
                                              AllPlansForMember.records.Small[2]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Small[2].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[0].planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[2].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="forcompany-web forcompany-mob">
                                        For companies that want to be more hands
                                        on
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[2]
                                                  ? AllPlansForMember.records
                                                      .Small[2].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[2]
                                                  ? AllPlansForMember.records
                                                      .Small[2].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Small &&
                                                  AllPlansForMember.records
                                                    .Small[2]
                                                  ? AllPlansForMember.records
                                                      .Small[2]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[2]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[2].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[2]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[2].planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small[2]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records.Small &&
                                              AllPlansForMember.records
                                                .Small[2] &&
                                              AllPlansForMember.records.Small[2]
                                                .planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[2] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Small[2].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>

                                      <div
                                        className={
                                          showTabPlan3
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            You decide which claims are filed{" "}
                                          </li>
                                          <li>Unlimited claim filings</li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                          <li>
                                            {" "}
                                            Each additional EIN is +$1.00/month
                                            <br /> (capped at $250/month)
                                          </li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan3: !showTabPlan3,
                                          });
                                        }}
                                      >
                                        {showTabPlan3
                                          ? "Show less"
                                          : "Show more"}
                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan3
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className=" plan-flex">
                                  <div
                                    className={
                                      activePlanForBussness === "Premium"
                                        ? "col m4  step-1"
                                        : "col m4 step-1 disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one">
                                      <h5 className="text-uppercase text-700 signup-title">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[0] &&
                                            AllPlansForMember.records
                                              .Enterprise[0].planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0].planName
                                          : ""}
                                      </h5>
                                      <h5 className="signup-title2">
                                        No Upfront Cost
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[0] &&
                                              AllPlansForMember.records
                                                .Enterprise[0]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Enterprise[0].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[0]
                                                .planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[0].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="font-medium forcompany-web forcompany-mob">
                                        For companies that want to try out
                                        Collectively
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[0]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[0].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[0]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[0].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[0]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[0]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[0]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[0].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[0]
                                                        .planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[0]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[0] &&
                                              AllPlansForMember.records
                                                .Enterprise[0].planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[0] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[0].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>
                                      <div
                                        className={
                                          showTabPlan
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            Visa/Mastercard claim included
                                          </li>
                                          <li>
                                            File upto 10 claims per entity{" "}
                                            <sup>2</sup>
                                          </li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                          <li>Upgrade at anytime</li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan: !showTabPlan,
                                          });
                                        }}
                                      >
                                        {showTabPlan
                                          ? "Show less"
                                          : "Show more"}

                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      activePlanForBussness === "Premium"
                                        ? "col m4 plan-2 step-2"
                                        : "col m4 step-2  disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one premium-plan">
                                      <span className="best-value text-700 text-uppercase">
                                        Best value
                                      </span>
                                      <h5 className="text-uppercase text-700 signup-title text-pink">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[1] &&
                                            AllPlansForMember.records
                                              .Enterprise[1].planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[1]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[1].planName
                                          : ""}
                                      </h5>
                                      <h5 className="signup-title2">
                                        $
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[1] &&
                                            AllPlansForMember.records
                                              .Enterprise[1].planPriceDto[0] &&
                                            AllPlansForMember.records.Enterprise[1].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[1].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[1].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )}
                                        /month <sup>1</sup>
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[1] &&
                                              AllPlansForMember.records
                                                .Enterprise[1]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Enterprise[1].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[0]
                                                .planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[1].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}{" "}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="font-medium forcompany-web forcompany-mob">
                                        For companies that want claims filed
                                        automatically
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[1]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[1].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[1]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[1].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[1]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[1]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[1]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[1].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[1]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[1]
                                                        .planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[1]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[1] &&
                                              AllPlansForMember.records
                                                .Enterprise[1].planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[1] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[1].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>
                                      <div
                                        className={
                                          showTabPlan1
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            Claims filed automatically{" "}
                                            <sup>2</sup>
                                          </li>
                                          <li>Unlimited claim filings</li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan1: !showTabPlan1,
                                          });
                                        }}
                                      >
                                        {showTabPlan1
                                          ? "Show less"
                                          : "Show more"}

                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan1
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      activePlanForBussness === "flex"
                                        ? "col m4 plan-3 step-3"
                                        : "step-3 disabled-plan-page"
                                    }
                                  >
                                    <div className="plan-one premium-plan">
                                      <h5 className="text-uppercase text-700 signup-title">
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[2] &&
                                            AllPlansForMember.records
                                              .Enterprise[2].planName
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[2]
                                          ? plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[2].planName
                                          : ""}{" "}
                                      </h5>
                                      <h5 className="signup-title2">
                                        $
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[2] &&
                                            AllPlansForMember.records
                                              .Enterprise[2].planPriceDto[0] &&
                                            AllPlansForMember.records.Enterprise[2].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[2].planPriceDto[0].subscriptionFees.toFixed(
                                              2
                                            )}
                                        /month <sup>1</sup>
                                      </h5>
                                      <p className="plan-small-font">
                                        Collectively keeps{" "}
                                        <b>
                                          {" "}
                                          {this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[2] &&
                                              AllPlansForMember.records
                                                .Enterprise[2]
                                                .planPriceDto[0] &&
                                              AllPlansForMember.records.Enterprise[2].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[0]
                                                .planPriceDto[0] &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[2].planPriceDto[0].fundCommission.toFixed(
                                                2
                                              )}
                                          %{" "}
                                        </b>{" "}
                                        of collected funds
                                      </p>
                                      <p className="font-medium forcompany-web forcompany-mob">
                                        For companies that want to be more hands
                                        on
                                      </p>
                                      <button
                                        onClick={() =>
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? this.onItemPlanClick(
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[2]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[2].planId
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[2]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[2].planName
                                                  : "",

                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records
                                                    .Enterprise &&
                                                  AllPlansForMember.records
                                                    .Enterprise[2]
                                                  ? AllPlansForMember.records
                                                      .Enterprise[2]
                                                  : ""
                                              )
                                            : this.onItemPlanClick(
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[2]
                                                  ? plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[2].planId
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[2]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[2]
                                                        .planName
                                                  : "",
                                                plansDataAffiliate &&
                                                  plansDataAffiliate.result &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[2]
                                                  ? plansDataAffiliate &&
                                                      plansDataAffiliate.result &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Small &&
                                                      plansDataAffiliate.result
                                                        .affiliateSubscriptionDto
                                                        .map.Enterprise[2]
                                                  : ""
                                              )
                                        }
                                        className={
                                          this.props.match.params
                                            .affiliateKey === undefined
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records
                                                .Enterprise &&
                                              AllPlansForMember.records
                                                .Enterprise[2] &&
                                              AllPlansForMember.records
                                                .Enterprise[2].planId === planId
                                              ? "waves-effect waves-light btn-small pink-btn"
                                              : "waves-effect waves-light btn-small white-btn"
                                            : plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[2] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map
                                                .Enterprise[2].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                        }
                                      >
                                        Select Plan
                                      </button>
                                      <div
                                        className={
                                          showTabPlan2
                                            ? "list-collapse d-list"
                                            : "list-collapse"
                                        }
                                      >
                                        <ul>
                                          <li>
                                            You decide which claims are filed{" "}
                                          </li>
                                          <li>Unlimited claim filings</li>
                                          <li>
                                            We collect claim forms for all
                                            entities
                                          </li>
                                          <li>
                                            Personalized dashboard and
                                            settlement alerts
                                          </li>
                                        </ul>
                                      </div>
                                      <div
                                        className="link-collapse"
                                        onClick={() => {
                                          this.setState({
                                            showTabPlan2: !showTabPlan2,
                                          });
                                        }}
                                      >
                                        {showTabPlan2
                                          ? "Show less"
                                          : "Show more"}

                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showTabPlan2
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <button
                                className="waves-effect waves-light white-btn payment-page-back-button"
                                type="submit"
                                onClick={() => {
                                  this.setState({ tabValue: 1 }, () => {
                                    window.scrollTo(0, 0);
                                  });
                                }}
                                name="action"
                              >
                                Back
                              </button>
                              <div className="plan-bottom">
                                <ol>
                                  <li>
                                    Yearly payment options available at
                                    checkout.
                                  </li>
                                  <li>
                                    Claims are automatically filed when claims
                                    data is readily available. We try to only
                                    contact you if additional information is
                                    necessary to start the claims process.
                                  </li>
                                </ol>
                                <div className="compare-plan-toggle">
                                  <div className="row">
                                    <div className="col s12">
                                      <p>
                                        <a
                                          onClick={() => {
                                            this.setState({
                                              showplanDetail: !showplanDetail,
                                            });
                                          }}
                                        >
                                          <span>Compare the value</span> of each
                                          plan{" "}
                                          <span className="down-arrow">
                                            {" "}
                                            <i
                                              className={
                                                showplanDetail
                                                  ? "material-icons angle-transposne"
                                                  : " material-icons"
                                              }
                                            >
                                              expand_more
                                            </i>
                                          </span>
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      showplanDetail
                                        ? "compare-plan-toggle-data"
                                        : "compare-plan-toggle-data-hide"
                                    }
                                  >
                                    <div className="row">
                                      <div className="col s12">
                                        <h6>
                                          Since settlements often take time to
                                          payout, below is an example of a
                                          company using Collectively over a 5
                                          year span. As shown in the chart, the
                                          Premium plan is the most efficient and
                                          offers the best value.
                                        </h6>
                                      </div>
                                      <div className="col s12 m4 plan-bottom-left">
                                        <h6 className="mt-mob-none text-uppercase">
                                          Example Recovery
                                        </h6>
                                        <h4>
                                          $50,000 <sup>3</sup>
                                        </h4>
                                        <h6 className="text-uppercase">
                                          Total Collected
                                        </h6>
                                        <ul>
                                          <li>10 Settlements</li>
                                          <li>
                                            $5,000 collected per Settlement
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col s12 m8 plan-bottom-right">
                                        <table className="table">
                                          <thead>
                                            <tr>
                                              <th />
                                              <th>Basic</th>
                                              <th>Premium</th>
                                              <th>Flex</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td>
                                                Monthly Fee (1 Ein over 5 years){" "}
                                                <sup>4</sup>
                                              </td>
                                              <td>$0.00</td>
                                              <td>$499.88</td>
                                              <td>$587.00</td>
                                            </tr>
                                            <tr>
                                              <td>Collectively keeps</td>
                                              <td>$ 9,975.00</td>
                                              <td>$ 4,975.00</td>
                                              <td>$ 6,975.00</td>
                                            </tr>
                                            <tr>
                                              <td>You Collect</td>
                                              <td>$40,025.00</td>
                                              <td>
                                                <b>$44,525.20</b>
                                              </td>
                                              <td>$42,438.00</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <ol>
                                          <li className="hidden" />
                                          <li className="hidden" />
                                          <li>
                                            The total recovery and average per
                                            settlement is for example purposes
                                            only. We are not estimating the
                                            actual value users might collect
                                            from settlements.
                                          </li>
                                          <li>
                                            The above example only includes 1
                                            EIN (Employer Identification
                                            Number/Tax ID Number)
                                          </li>
                                        </ol>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>

                        <TabPanel>
                          <div
                            ref={(section) => {
                              this.signatureRef = section;
                            }}
                            className={
                              !IsSignatureForm
                                ? "section-content left-align create-signature"
                                : "hide"
                            }
                          >
                            <TermAndCondition
                              termsAndConditionData={this.handleSaveData}
                              termsAndConditionDataNextPage={
                                this.handleSaveDataNext
                              }
                              termsAndConditionBack={this.backClick}
                              readDisclaimer={readDisclaimer}
                              readUserAgreement={readUserAgreement}
                              readPrivacyPolicy={readPrivacyPolicy}
                              readLetterOfAgency={readLetterOfAgency}
                              pageType="business"
                              backButton
                              signupData={this.state}
                              defaultValue={signatureDefaultValue}
                              fontFamily={signatureFontFamily}
                              // finalSubmitData={this.finalSubmit}
                              fileImage={this.fileImage}
                              moveTop={this.topScreen}
                              fileData={file}
                              hide
                              makepayment={
                                planName === "Basic" || connectFusebill === 0
                              }
                              selectedPlanAmount={selectedPlanAmount}
                            />
                          </div>
                          {/* <div ref={(section) => { this.signatureRef = section; }} className={IsSignatureForm ? 'section-content left-align create-signature' : 'hide'}>
                            <SignatureComponent
                              defaultValue={signatureDefaultValue}
                              fontFamily={signatureFontFamily}
                              signBack={this.backClickSignature}
                              finalSubmitData={this.finalSubmit}
                              fileImage={this.fileImage}
                              signupData={this.state}
                              moveTop={this.topScreen}
                              fileData={file}
                              loader={isLoading}
                              hide
                            />
                          </div> */}
                        </TabPanel>

                        <TabPanel
                          className={
                            planName === "Basic" || connectFusebill === 0
                              ? "hide-tab-info"
                              : ""
                          }
                        >
                          <div className="signup-tab-align">
                            <div
                              id="checkout-tab"
                              className="col s12 main-content signup-new-tabs-content ibmfont"
                            >
                              <h4 className="center-align signup-title">
                                Checkout
                              </h4>
                              <a
                                className="change-plan change-plan-mob"
                                onClick={() => {
                                  this.setState({
                                    tabValue: 2,
                                  });
                                }}
                              >
                                Change Plan
                              </a>
                              <p className="center-align signup-title2 checkout-tagline-mob">
                                Choose a payment term for your {planName} plan:
                              </p>

                              <div className="row">
                                <div className="col s12 l10 offset-l1">
                                  <ul className="tabs">
                                    {this.props.match.params.affiliateKey ===
                                    undefined
                                      ? AllPlansForMember &&
                                        AllPlansForMember.records &&
                                        AllPlansForMember.records[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          (item1) => item1.planName === planName
                                        ) !== -1
                                        ? AllPlansForMember.records[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ][
                                            AllPlansForMember.records[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              (item1) =>
                                                item1.planName === planName
                                            )
                                          ] &&
                                          AllPlansForMember.records[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ][
                                            AllPlansForMember.records[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              (item1) =>
                                                item1.planName === planName
                                            )
                                          ].planPriceDto.map((iteam, index) => (
                                            <li key={index} className="tab">
                                              <a
                                                className={
                                                  iteam.planPriceId ===
                                                  planPriceId
                                                    ? "active"
                                                    : ""
                                                }
                                                onClick={() =>
                                                  this.selectPricePlainDetail(
                                                    iteam.planPriceId,
                                                    iteam.subscriptionFees,
                                                    iteam.durationType,
                                                    iteam.duration,
                                                    iteam.fusebillPlanId,
                                                    iteam.fusebillPlanFrequencyId,
                                                    iteam.connectFusebill,
                                                    iteam.durationType ===
                                                      "Month"
                                                      ? 1
                                                      : 12 * iteam.duration,
                                                    index !== 0
                                                      ? 1 -
                                                          (index * 5 + 5) / 100
                                                      : 0
                                                  )
                                                }
                                              >
                                                {iteam.duration !== 1
                                                  ? iteam.duration
                                                  : ""}{" "}
                                                {iteam.durationType === "Month"
                                                  ? "Monthly"
                                                  : iteam.duration > 1
                                                  ? "Years"
                                                  : "Yearly"}
                                                <span
                                                  className={
                                                    iteam.durationType ===
                                                    "Month"
                                                      ? "monthly-price"
                                                      : ""
                                                  }
                                                >
                                                  {iteam.durationType ===
                                                  "Month"
                                                    ? `$${iteam.subscriptionFees.toFixed(
                                                        2
                                                      )}`
                                                    : `SAVE ${5 + index * 5} %`}
                                                </span>
                                              </a>
                                            </li>
                                          ))
                                        : ""
                                      : plansDataAffiliate &&
                                        plansDataAffiliate.result &&
                                        plansDataAffiliate.result
                                          .affiliateSubscriptionDto &&
                                        plansDataAffiliate.result
                                          .affiliateSubscriptionDto.map &&
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          (item1) => item1.planName === planName
                                        ) !== -1
                                      ? plansDataAffiliate.result
                                          .affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ][
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            (item1) =>
                                              item1.planName === planName
                                          )
                                        ] &&
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ][
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            (item1) =>
                                              item1.planName === planName
                                          )
                                        ].planPriceDto.map((iteam, index) => (
                                          <li key={index} className="tab">
                                            <a
                                              className={
                                                iteam.planPriceId ===
                                                planPriceId
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() =>
                                                this.selectPricePlainDetail(
                                                  iteam.planPriceId,
                                                  iteam.subscriptionFees,
                                                  iteam.durationType,
                                                  iteam.duration,
                                                  iteam.fusebillPlanId,
                                                  iteam.fusebillPlanFrequencyId,
                                                  iteam.connectFusebill,
                                                  iteam.durationType === "Month"
                                                    ? 1
                                                    : 12 * iteam.duration,
                                                  index !== 0
                                                    ? 1 - (index * 5 + 5) / 100
                                                    : 0
                                                )
                                              }
                                            >
                                              {iteam.duration !== 1
                                                ? iteam.duration
                                                : ""}{" "}
                                              {iteam.durationType === "Month"
                                                ? "Monthly"
                                                : iteam.duration > 1
                                                ? "Years"
                                                : "Yearly"}
                                              <span
                                                className={
                                                  iteam.durationType === "Month"
                                                    ? "monthly-price"
                                                    : ""
                                                }
                                              >
                                                {iteam.durationType === "Month"
                                                  ? `$${iteam.subscriptionFees.toFixed(
                                                      2
                                                    )}`
                                                  : `SAVE ${5 + index * 5} %`}
                                              </span>
                                            </a>
                                          </li>
                                        ))
                                      : ""}
                                  </ul>

                                  <div className="clear tab-inner p-x-none-mob">
                                    <div
                                      id="plan1"
                                      className="col s12 p-x-none-mob sign-tab-content center-align pad-x-none"
                                    >
                                      <div className="plan-detail">
                                        <div className="row">
                                          <div className="col s12 p-x-none-mob">
                                            {enterpriseType === "S" ? (
                                              <p className="per-mnth-plan">
                                                Each additional EIN is
                                                +$1.00/month (capped at
                                                $250/month)
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                            {durationData !== "1 Month" ? (
                                              <p className="per-year-plan right-align">
                                                Your Total for{" "}
                                                {enterpriseType === "S"
                                                  ? totalTaxId > 0
                                                    ? `${
                                                        parseInt(
                                                          totalTaxId,
                                                          10
                                                        ) + 1
                                                      }  EINs over `
                                                    : `1 EIN over `
                                                  : ""}{" "}
                                                {durationData === "1 year"
                                                  ? `${durationData} `
                                                  : `${durationData}s `}
                                                is{" "}
                                                <span>
                                                  $
                                                  {(
                                                    parseFloat(
                                                      selectedPlanAmount !== ""
                                                        ? selectedPlanAmount.toFixed(
                                                            2
                                                          )
                                                        : 0.0
                                                    ) +
                                                    parseFloat(
                                                      enterpriseType === "S"
                                                        ? totalTaxId < 250
                                                          ? totalTaxId *
                                                            durationCheckout *
                                                            discountCheckout
                                                          : 250 *
                                                            durationCheckout *
                                                            discountCheckout
                                                        : 0.0
                                                    )
                                                  ).toFixed(2)}{" "}
                                                  /{" "}
                                                  {durationData === "1 year"
                                                    ? `year`
                                                    : `${durationData}s `}
                                                </span>
                                              </p>
                                            ) : (
                                              <table className="checkout-table">
                                                <tbody>
                                                  <tr>
                                                    <td className="right-align">
                                                      Your Current Plan
                                                    </td>
                                                    <td className="right-align">
                                                      $
                                                      {selectedPlanAmount !== ""
                                                        ? selectedPlanAmount.toFixed(
                                                            2
                                                          )
                                                        : 0.0}
                                                    </td>
                                                  </tr>
                                                  {enterpriseType === "S" && (
                                                    <tr>
                                                      <td className="right-align">
                                                        + {totalTaxId} EINs
                                                      </td>
                                                      <td className="right-align">
                                                        $
                                                        {parseFloat(
                                                          enterpriseType === "S"
                                                            ? totalTaxId < 250
                                                              ? totalTaxId
                                                              : 250
                                                            : 0.0
                                                        ).toFixed(2)}
                                                      </td>
                                                    </tr>
                                                  )}
                                                  <tr>
                                                    <td className="right-align">
                                                      <b>Monthly Total</b>
                                                    </td>
                                                    <td className="right-align total">
                                                      <b>
                                                        $
                                                        {(
                                                          parseFloat(
                                                            selectedPlanAmount !==
                                                              ""
                                                              ? selectedPlanAmount.toFixed(
                                                                  2
                                                                )
                                                              : 0.0
                                                          ) +
                                                          parseFloat(
                                                            enterpriseType ===
                                                              "S"
                                                              ? totalTaxId < 250
                                                                ? totalTaxId
                                                                : 250
                                                              : 0.0
                                                          )
                                                        ).toFixed(2)}{" "}
                                                        / month
                                                      </b>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    {/* <td
                                                      className="right-align contingent-fee"
                                                      colSpan="2"
                                                    >
                                                      Plus any contingent fees
                                                  </td> */}
                                                  </tr>
                                                </tbody>
                                              </table>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      id="plan2"
                                      className="col s12 sign-tab-content center-align pad-x-none"
                                    />
                                    <div
                                      id="plan3"
                                      className="col s12 sign-tab-content center-align pad-x-none"
                                    >
                                      {" "}
                                    </div>
                                    <div
                                      id="plan4"
                                      className="col s12 sign-tab-content center-align pad-x-none"
                                    >
                                      {" "}
                                    </div>
                                  </div>

                                  {planName !== "Basic" &&
                                  (planName,
                                  this.props.match.params.affiliateKey ===
                                  undefined
                                    ? 1
                                    : plansDataAffiliate &&
                                      plansDataAffiliate.result &&
                                      plansDataAffiliate.result
                                        .affiliateSubscriptionDto &&
                                      plansDataAffiliate.result
                                        .affiliateSubscriptionDto.map &&
                                      plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ].findIndex(
                                        (item1) => item1.planName === planName
                                      ) !== -1
                                    ? plansDataAffiliate.result
                                        .affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ][
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          (item1) => item1.planName === planName
                                        )
                                      ] &&
                                      plansDataAffiliate.result
                                        .affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ][
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          (item1) => item1.planName === planName
                                        )
                                      ].planPriceDto[0].connectFusebill === 1
                                      ? 1
                                      : 0
                                    : 0) !== 0 ? (
                                    <div id="info-tab" className="row">
                                      <form className="tab-inner p-x-none-mob">
                                        <div className="row">
                                          <div className="col s12 pb-20 pad-x-none">
                                            <h6 className="signup-title checkout-title checkout-title-uppercase">
                                              Enter your card information
                                            </h6>

                                            <p>
                                              <label>
                                                <input
                                                  className="with-gap"
                                                  name="group5"
                                                  type="checkbox"
                                                  onChange={this.cardOnChange}
                                                  checked={sameAddress}
                                                />
                                                <span className="text-black">
                                                  Same as address from Signup
                                                </span>
                                              </label>
                                            </p>
                                          </div>
                                          <CardInputMaskinking
                                            divClassName="input-field col s12 pb-20 pad-x-none"
                                            field="cardNumber"
                                            label="Card Number *"
                                            placeholder="Card Number"
                                            value={cardNumber}
                                            error={cardErrors.cardNumber}
                                            onChange={this.onChangeCarad}
                                            mask="9999 9999 9999 9999"
                                          />

                                          <CardInputField
                                            divClassName="input-field col s12 m6 pb-20 pad-x-none"
                                            field="cardFirstName"
                                            label="First Name *"
                                            // placeholder="Name on Card"
                                            value={cardFirstName}
                                            error={cardErrors.cardFirstName}
                                            onChange={this.onChangeCarad}
                                          />
                                          <CardInputField
                                            divClassName="input-field col s12 m6 claimaint-input-half-rt pb-20 pad-x-none"
                                            field="cardLastName"
                                            label="Last Name  *"
                                            // placeholder="Name on Card"
                                            value={cardLastName}
                                            error={cardErrors.cardLastName}
                                            onChange={this.onChangeCarad}
                                          />

                                          <div className="pb-20 pad-x-none clear">
                                            <div className="row">
                                              <CardInputMaskinking
                                                divClassName="input-field col s4 pad-x-none"
                                                field="cardMonth"
                                                label="Month *"
                                                placeholder="Month"
                                                value={cardMonth}
                                                error={cardErrors.cardMonth}
                                                onChange={this.onChangeCarad}
                                                mask="99"
                                              />

                                              <CardInputMaskinking
                                                divClassName="input-field col s4 pad-x-none checkoutyear-input"
                                                field="cardYear"
                                                label="Year *"
                                                placeholder="Year"
                                                value={cardYear}
                                                error={cardErrors.cardYear}
                                                onChange={this.onChangeCarad}
                                                mask="99"
                                              />

                                              <CardInputMaskinking
                                                divClassName="input-field col s4 pad-x-none"
                                                field="cardCvv"
                                                label="CVV *"
                                                placeholder="CVV"
                                                value={cardCvv}
                                                error={cardErrors.cardCvv}
                                                onChange={this.onChangeCarad}
                                                mask="9999"
                                              />
                                            </div>
                                          </div>

                                          <CardInputField
                                            divClassName="input-field col s12 pb-20 pad-x-none"
                                            field="cardAddress"
                                            label="Address *"
                                            // placeholder="Address"
                                            value={cardAddress}
                                            error={cardErrors.cardAddress}
                                            onChange={this.onChangeCarad}
                                          />

                                          <CardInputField
                                            divClassName="input-field col s12 pb-20 pad-x-none"
                                            field="cardAddress2"
                                            label="Address 2"
                                            // placeholder="Address"
                                            value={cardAddress2}
                                            onChange={this.onChangeCarad}
                                          />

                                          <div className="row city-state-zip">
                                            <CardInputField
                                              divClassName="input-field col s12 m5 pb-20-mob pad-x-none "
                                              field="cardCity"
                                              label="City *"
                                              // placeholder="City"
                                              value={cardCity}
                                              error={cardErrors.cardCity}
                                              onChange={this.onChangeCarad}
                                            />

                                            <div className="input-field col s12 col m3 pb-20-mob pad-x-none">
                                              <label className="active">
                                                State*
                                              </label>
                                              <select
                                                name="state"
                                                value={stateCard}
                                                onChange={this._onSelectCard}
                                                onClick={this._onSelectCard}
                                                className="state-select"
                                              >
                                                {typeof options !== "undefined"
                                                  ? options
                                                  : ""}
                                              </select>

                                              {/* <div className="col s4 input-half-lt custom-select">
                                        <label className="active font-scale">State*</label>
                                        <select name="state" onChange={this._onSelect}>
                                          {(typeof options !== 'undefined') ? (options) : ''}
                                        </select> */}

                                              <span
                                                className={
                                                  cardErrors.stateCardError
                                                    ? "show invalid dropdown-error-msg"
                                                    : "hide"
                                                }
                                              >
                                                {cardErrors.stateCard}
                                              </span>
                                            </div>
                                            <CardInputMaskinking
                                              divClassName="input-field col s12 m4 pad-x-none"
                                              field="cardZipCode"
                                              label="Zip Code *"
                                              // placeholder="Zip Code"
                                              value={cardZipCode}
                                              error={cardErrors.cardZipCode}
                                              onChange={this.onChangeCarad}
                                              mask="99999"
                                            />
                                          </div>
                                          <div className="col s12 input-field pad-x-none">
                                            <ReCAPTCHA
                                              ref={this.recaptchaRef}
                                              sitekey={
                                                SecretKeys.FusebillCaptchKeys
                                              }
                                              onChange={this.onReCaptchaChange}
                                              onExpired={() => {
                                                this.setState((prevState) => ({
                                                  cardErrors: {
                                                    ...prevState.cardErrors,
                                                    recaptchaTokenError: true,
                                                  },
                                                }));
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div className="tab-inner center-align input-field claimant-btns checkout-btns pl-none">
                                    <button
                                      onClick={() => {
                                        this.setState({ tabValue: 3 }, () => {
                                          window.scrollTo(0, 0);
                                        });
                                      }}
                                      className="waves-effect waves-light white-btn back-button back-button2 back-btn-pad-mob ml-mob-none"
                                      type="submit"
                                      name="action"
                                    >
                                      Back
                                    </button>
                                    <button
                                      className={
                                        this.props.match.params.affiliateKey ===
                                        undefined
                                          ? (planName !== "Basic" &&
                                            (planName,
                                            AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              (item1) =>
                                                item1.planName === planName
                                            ) !== -1
                                              ? AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  AllPlansForMember &&
                                                    AllPlansForMember.records &&
                                                    AllPlansForMember.records[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      (item1) =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                ] &&
                                                AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  AllPlansForMember &&
                                                    AllPlansForMember.records &&
                                                    AllPlansForMember.records[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      (item1) =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                ].planPriceDto[0]
                                                  .connectFusebill === 1
                                                ? 1
                                                : 0
                                              : 0) !== 0
                                              ? isEmpty(cardErrors)
                                              : true) &&
                                            selectedPlanAmount !== ""
                                            ? "waves-effect waves-light pink-btn back-btn-pad-mob"
                                            : "waves-effect waves-light ltgrey-btn make-payment-action back-btn-pad-mob"
                                          : (planName !== "Basic" &&
                                            (planName,
                                            plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              (item1) =>
                                                item1.planName === planName
                                            ) !== -1
                                              ? plansDataAffiliate.result
                                                  .affiliateSubscriptionDto.map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    (item1) =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                                ] &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto.map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    (item1) =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                                ].planPriceDto[0]
                                                  .connectFusebill === 1
                                                ? 1
                                                : 0
                                              : 0) !== 0
                                              ? isEmpty(cardErrors)
                                              : true) &&
                                            selectedPlanAmount !== ""
                                          ? "waves-effect waves-light pink-btn back-btn-pad-mob"
                                          : "waves-effect waves-light ltgrey-btn make-payment-action back-btn-pad-mob"
                                      }
                                      onClick={this.finalSubmit}
                                      disabled={
                                        this.props.match.params.affiliateKey ===
                                        undefined
                                          ? !(
                                              (planName !== "Basic" &&
                                              (planName,
                                              AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ].findIndex(
                                                (item1) =>
                                                  item1.planName === planName
                                              ) !== -1
                                                ? AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ][
                                                    AllPlansForMember &&
                                                      AllPlansForMember.records &&
                                                      AllPlansForMember.records[
                                                        enterpriseType === "S"
                                                          ? "Small"
                                                          : "Enterprise"
                                                      ].findIndex(
                                                        (item1) =>
                                                          item1.planName ===
                                                          planName
                                                      )
                                                  ] &&
                                                  AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ][
                                                    AllPlansForMember &&
                                                      AllPlansForMember.records &&
                                                      AllPlansForMember.records[
                                                        enterpriseType === "S"
                                                          ? "Small"
                                                          : "Enterprise"
                                                      ].findIndex(
                                                        (item1) =>
                                                          item1.planName ===
                                                          planName
                                                      )
                                                  ].planPriceDto[0]
                                                    .connectFusebill === 1
                                                  ? 1
                                                  : 0
                                                : 0) !== 0
                                                ? isEmpty(cardErrors)
                                                : true) &&
                                              selectedPlanAmount !== ""
                                            )
                                          : !(
                                              (planName !== "Basic" &&
                                              (planName,
                                              plansDataAffiliate &&
                                              plansDataAffiliate.result &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map &&
                                              plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ].findIndex(
                                                (item1) =>
                                                  item1.planName === planName
                                              ) !== -1
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ][
                                                    plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      (item1) =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                  ] &&
                                                  plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ][
                                                    plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      (item1) =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                  ].planPriceDto[0]
                                                    .connectFusebill === 1
                                                  ? 1
                                                  : 0
                                                : 0) !== 0
                                                ? isEmpty(cardErrors)
                                                : true) &&
                                              selectedPlanAmount !== ""
                                            )
                                      }
                                      type="submit"
                                      name="action"
                                    >
                                      Submit Payment
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </Tabs>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

Signup.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  data: state.data,
  signupData: state.signupData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveBusinessUserPatner,
      saveBusinessUserStep1,
      getAllCountry,
      planPriceChange,
      getAllStates,
      getCityByStateId,
      getAffiliateDetailByAffiliateKey,
      getAllPlans,
      confirmUserEmail,
      clearData,
      getIndustry,
      getBusiness,
      checkEmailVerify,
      requestApiData,
      getPageDataFooter,
      getPageData,
      clearDataEmail,
      clearSignupData,
      saveConsumerUser,
      GetAllAffiliateUsersByAffiliateType,
      setPageName,
    },
    dispatch
  );
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));
